/* eslint-disable camelcase */

export default {
  action: {
    back: 'Zurück',
    cancel: 'Abbrechen',
    close: 'Schliessen',
    collapseDetails: 'Weniger anzeigen',
    confirm: 'Weiter',
    confirmAndInvite: 'Weiter und Einladen',
    continue: 'Weiter',
    createAccount: 'Konto erstellen',
    expandDetails: 'Details',
    invite: 'Einladen',
    logout: 'Abmelden',
    no: 'Nein',
    openSwitchOrganisation: 'Firma auswählen:',
    organisation: 'Firma (Niederlassung)',
    resendEmail: 'Erneut senden',
    returnToHome: 'Zur Homepage',
    settings: 'Konto',
    skip: 'Ignorieren',
    yes: 'Ja'
  },
  activateUser: {
    button: 'erneut senden',
    emailSent: 'Wir haben eine neue E-Mail gesandt',
    linkLabel: 'Direkt zu meinem Konto',
    message: 'Wir haben eine E-Mail an %{email} gesandt',
    messageLink: 'Ich habe schon aktiviert',
    resendMessage: 'Ich habe kein Email erhalten, ',
    subMessage: 'Bitte klicken Sie auf den Registrierungslink um Ihr Nutzerkonto zu bestätigen.',
    title: 'Danke, dass Sie ein Konto mit OnceForAll erstellt haben'
  },
  address: {
    addressLine: 'Strasse',
    city: 'Ort',
    country: 'Land',
    region: 'Region',
    postCode: 'PLZ',
    title: 'Adresse'
  },
  bdr: {
    access: {
      confirm: 'Go to Bâtisseur de Relations',
      collector: {
        text1: '__sBâtisseur de Relations : A unique business platform to find your future projects__s',
        text2: '__sLooking for a new supplier for a specific project?__s',
        text3: 'Bâtisseur de Relations platform allows you to :',
        text4: '  - Publish projects and search for suppliers according to your criteria and needs.',
        text5: '  - Find pre-qualified suppliers.',
        text6: '  - Ensure compliance for all your operations.',
        text7: '__sSave time in sourcing and focus on your core business with Bâtisseur de Relations !__s',
        text8: 'By clicking on "%{confirm}", your user account and your companies on OnceForAll platform will be automatically synced.'
      },
      depositor: {
        text1: '__sBâtisseur de Relations : A unique business platform to find your future projects.__s',
        text2: '__sDo you want to develop your business?__s',
        text3: 'Bâtisseur de Relations platform allows you to :',
        text4: '  - Search and consult public tenders.',
        text5: '  - Receive projects from private contractors.',
        text6: '  - Be listed on the largest network of construction companies in France.',
        text7: '__sSave time searching for projects and win new contracts with Bâtisseur de Relations !__s',
        text8: 'By clicking on "%{confirm}", your user account and your companies on OnceForAll platform will be automatically synced.'
      }
    },
    discover: {
      collector: {
        dashboard: {
          text: "Find qualified suppliers for your future projects from France's largest construction network."
        },
        other: {
          text: "Find qualified suppliers for your future projects from France's largest construction network."
        }
      },
      confirm: 'Try now',
      depositor: {
        text: 'Find new public and private business opportunities on a single platform and grow your business!'
      },
      title: '__sBâtisseur de Relations :__s'
    },
    errorNoUserAndBdrService: {
      text1: 'Beim Erstellen Ihres Marketplace-Profils ist ein Fehler aufgetreten. Wir entschuldigen uns für die Unannehmlichkeiten.',
      text2: 'Bitte informieren Sie uns unter der folgenden Adresse : <a href="mailto:service.clients@onceforall.fr" title="mailto:service.clients@onceforall.fr">service.clients@onceforall.fr</a>.',
      text3: 'Bis bald auf unserer Plattform, das Once For All-Team'
    },
    errorNoBdrService: {
      text1: 'Ihr aktuelles Angebot ermöglicht Ihnen keinen Zugang zu diesem Service. Wir entschuldigen uns für die Unannehmlichkeiten.',
      text2: '👉 <a href="/alg/organisation/subscription">Mein Angebot ansehen</a>',
      text3: 'Bis bald auf unserer Plattform!'
    }
  },
  banette: {
    documentName: 'Dokumentname',
    explanatoryTooltip: 'Dokumente, die in den Nachweisordner eingestellt werden, sind für alle Pojektteilnehmer sichtbar.',
    noDocument: 'Es gibt kein allgemeines Projektdokument in Ihrer Liste.',
    pleaseAddDocument: 'Klicken Sie auf "Neues Dokument einstellen" um ein allgemeines Projektdokument hinzuzufügen.',
    requireCCRD: '[Require Attestation Décennale Nominative]',
    requireCRSE: '[Require Charte RSE]',
    uploadNewDocument: 'Dokument einstellen',
    widgetTitle: 'Allgemeine Dokumente'
  },
  client: {
    accessCode: {
      additionalInformation: 'zusätzliche Informationen',
      clientOrgName: 'Name des Auftraggebers',
      generateButton: 'Zugangscode erstellen',
      generateText: 'Zugangscode erstellen',
      generateWarning: 'Sie können nür die Französen Kunden einladen.',
      responseToAccessCode: 'An Ausschreibung beteiligen',
      tenderReference: 'Ausschreibungsnummer'
    },
    add: {
      button: 'Kunde hinzufügen',
      inviteSuccess: 'Die Firma %{name} wurde zu Ihrer Kundenliste hinzugefügt.',
      notice: 'Der Kunde wird auf Ihre Nachweise zugreifen können.',
      title: 'Kunde hinzufügen'
    },
    documents: 'Meine Dokumente für %{clientName}',
    invitations: {
      actions: {
        accept: 'Annehmen',
        decline: 'Ablehnen',
        resend: 'Erneut senden',
        tooltip: 'Sie müssen mindestens %{count} Tage warten, bevor Sie die Einladung erneut senden können'
      },
      noSent: 'Keine Einladung zur Ausstellung',
      received: 'Erhaltene Einladungen',
      sent: 'Versandte Einladungen'
    },
    invite: {
      defaultMessage: 'Mit dem Ziel die Nachweisverwaltung zu erleichtern, bittet Sie %{userName} von Ihrem Nachunternehmer %{organisationName}, sich über folgenden Link auf OnceForAll anzumelden.\nAls Auftraggeber haben Sie anschließend kostenlosen Zugriff auf die geprüften Nachweise von %{organisationName} .\nOnceForAll ist ein unabhängiges Dienstleistungsangebot. Es trägt zur Sicherung Ihrer Geschäftsbeziehungen bei, indem es Nachunternehmern hilft einen jederzeit vollständigen und aktuellen Nachweisordner vorzuhalten.',
      inviteSuccess: 'Sobald sich der eingeladene Nutzer bei OnceForAll registriert und seine Organisation hinzufügt, wird diese Firma automatisch mit Ihrer als einer ihrer Kunden verknüpft.',
      title: 'Einen Auftraggeber einladen'
    },
    myClients: 'Kunden',
    relationshipAccepted: 'Die Einladung Ihres Kunden wurde angenommen.',
    relationshipAlreadyReplied: 'Diese Einladung haben Sie bereits beantwortet',
    relationshipRejected: 'Die Einladung Ihres Kunden wurde abgelehnt.',
    search: {
      notFound: 'Keine Auftraggeber gefunden'
    }
  },
  contact: {
    content: 'Details',
    creationSuccess: 'Ihre Anfrage wurde entgegengenommen',
    email: 'kontakt.de@onceforall.com',
    horary: {
      alg_fr: 'Geöffnet Montag bis Donnerstag von 8:30 bis 12:30 und von 13:30 bis 18:00. Freitag von 8:30 bis 12:30 und 13:30 bis 17:00',
      ofa_de: 'Geöffnet Montag bis Freitag von 9 bis 17 Uhr',
      ofa_it: 'Geöffnet Montag bis Donnerstag von 8:30 bis 12:30 und von 13:30 bis 18:00. Freitag von 8:30 bis 12:30 und 13:30 bis 17:00'
    },
    phone: {
      alg_fr: '+33 4 72 38 32 58',
      ofa_de: '+49 30 397 160 82',
      ofa_it: '+39 02 3056 9038'
    },
    subtype: 'Und genauer',
    title: 'Kontakt',
    type: 'Ihre Anfrage betrifft',
    types: {
      FileClaim: 'Beschwerde',
      IdeaSuggestion: 'Vorschlag, User Experience Feedback',
      MyCustomers: 'Meine Kunden',
      MyDocuments: 'Meine Nachweise',
      MyOffer: 'Mein Angebot',
      MyProjects: 'Meine Projekte',
      MyReferencesList: 'Meine Referenzliste im Bauwesen',
      MyRole: 'Meine Nutzerrolle',
      MySettings: 'Meine Einstellungen',
      MySuppliers: 'Meine Nachunternehmer',
      MyTraining: 'Mein Training'
    }
  },
  country: {
    ANDORRA: 'Andorra',
    AUSTRIA: 'Österreich',
    BELGIUM: 'Belgien',
    BOLIVIA: 'Bolivien',
    BULGARIA: 'Bulgarien',
    CROATIA: 'Kroatien',
    CZECH_REPUBLIC: 'Tschechische Republik',
    DENMARK: 'Dänemark',
    ESTONIA: 'Estland',
    FRANCE: 'Frankreich',
    GERMANY: 'Deutschland',
    GREECE: 'Griechenland',
    HUNGARY: 'Ungarn',
    ICELAND: 'Island',
    INDIA: 'Indien',
    ITALY: 'Italien',
    IVORY_COAST: 'Elfenbeinküste',
    LATVIA: 'Lettland',
    LITHUANIA: 'Litauen',
    LUXEMBOURG: 'Luxemburg',
    MAURITIUS: 'Mauritius',
    MEXICO: 'Mexiko',
    MONACO: 'Monaco',
    NETHERLANDS: 'Niederlande',
    POLAND: 'Polen',
    PORTUGAL: 'Portugal',
    ROMANIA: 'Romania',
    SERBIA: 'Serbien',
    SLOVAKIA: 'Slowakei',
    SLOVENIA: 'Slowenien',
    SPAIN: 'Spanien',
    SWEDEN: 'Schweden',
    SWITZERLAND: 'Schweiz',
    UNITED_KINGDOM: 'Vereinigtes Königreich',
    flags: {
      AD: 'Andorra',
      AT: 'Österreich',
      BE: 'Belgien',
      BG: 'Bulgarien',
      BO: 'Bolivien',
      CH: 'Schweiz',
      CI: 'Elfenbeinküste',
      CZ: 'Tschechische Republik',
      DE: 'Deutschland',
      DK: 'Dänemark',
      EE: 'Estland',
      ES: 'Spanien',
      FR: 'Frankreich',
      GB: 'Vereinigtes Königreich',
      GR: 'Griechenland',
      HR: 'Kroatien',
      HU: 'Ungarn',
      IN: 'Indien',
      INTERNATIONAL: 'International',
      IS: 'Island',
      IT: 'Italien',
      LT: 'Litauen',
      LU: 'Luxemburg',
      LV: 'Lettland',
      MC: 'Monaco',
      MU: 'Mauritius',
      MX: 'Mexiko',
      NL: 'Niederlande',
      PL: 'Polen',
      PT: 'Portugal',
      RO: 'Romania',
      RS: 'Serbien',
      SE: 'Schweden',
      SI: 'Slowenien',
      SK: 'Slowakei'
    }
  },
  dashboard: {
    deactivated: {
      action: 'Kontakt',
      message: 'Bitte kontaktieren Sie uns, wenn Sie einen Zahlungsplan erstellen und die Firma reaktivieren möchten.',
      title: 'Ihre Firma wurde deaktiviert'
    },
    documents: 'Nachweise',
    documentsToProcess: {
      action: {
        sign: 'Dieses Dokument unterschrieben',
        upload: 'Dieses Dokument auswählen'
      },
      emptyList: 'Alle Ihre Nachweise wurden verarbeitet',
      expandList: 'Alle zu verarbeitenden Beweise sehen',
      message: {
        AWAITING_SIGNATURE: 'muß unterzeichnet werden',
        EXPIRED: 'ist seit %{expirationDate} nicht mehr gültig',
        MISSING: 'fehlt',
        REJECTED: 'wurde aus folgendem Grund abgelehnt:'
      },
      title: 'Zu verarbeitende Nachweise'
    },
    stats: {
      clients: 'Kunden',
      link: {
        clients: 'Alle Kunden sehen',
        projects: 'Alle Projekte sehen',
        subcontractors: 'Alle Nachunternehmer sehen',
        users: 'Alle Benutzer sehen'
      },
      projects: 'Projekte',
      subcontractors: {
        nationality: {
          FRANCE: 'französischen',
          GERMANY: 'deutschen',
          ITALY: 'italienischen'
        },
        title: 'Nachunternehmer',
        valid: 'der Nachunternehmer dieser Firma haben einen gültigen %{nationality} Nachweisordner'
      },
      users: 'Nutzer'
    }
  },
  datetime: {
    datePickerMask: [
      'd',
      'd',
      '/',
      'd',
      'd',
      '/',
      'd',
      'd',
      'd',
      'd'
    ],
    shortDate: 'DD/MM/YYYY',
    shortDatetime: 'DD/MM/YYYY HH:mm',
    undefined: '-'
  },
  document: {
    addAdditionalDesignation: 'Zusatzbezeichnung hinzufügen',
    additionalDesignation: 'Zusatzbezeichnung',
    additionalDesignationNotice: 'Für gleichartige Dokumente',
    additionalDesignationSuccessUpdate: 'Die Zusatzbezeichnung wurde hinzugefügt',
    all: 'Alle Dokumente',
    canNotDownload: 'Dieses Dokument kann nicht angezeigt werden.',
    changeFile: 'Datei ändern',
    chart: {
      almostExpired: 'Dokumente bald ungültig',
      almostExpired_1: 'Dokument bald ungültig',
      awaiting: 'Dokumente in Bearbeitung',
      awaiting_1: 'Dokumente in Bearbeitung',
      percentageLabel: 'Gültig',
      seeMyDocuments: 'Siehe meine Dokumente',
      title: 'Status meines Nachweisordners',
      todo: 'Dokumente zu bearbeiten',
      todo_1: 'Dokumente zu bearbeiten',
      valid: 'Gültige Dokumente',
      valid_1: 'Gültiges Dokument'
    },
    checkFile: 'Dokument überprüfen',
    chooseOnComputer: 'Auswählen hinzufügen',
    collectionMandateEnabled: {
      FRANCE: 'Von Attestation Légale abgerufen',
      GERMANY: 'Von OnceForAll abgerufen'
    },
    consultMyArchivedDocuments: 'Meine Archive einsehen',
    consultMyDocuments: 'Zurück zu Nachweisen',
    delete: 'Entfernen',
    documentDetails: {
      addNewVersion: 'Neue Version einstellen',
      documentExample: 'Für Beispiel klicken',
      documentIsGathered: {
        FRANCE: 'Dieser Nachweis wird von Attestation Légale abgerufen.',
        GERMANY: 'Dieser Nachweis wird von OnceForAll abgerufen.'
      },
      documentIsRejected: 'Dieses Dokument wurde abgelehnt. Für weitere Informationen klicken Sie bitte hier.',
      documentVersionIsAwaitingSignature: 'Eine Version dieses Dokumentes muss signiert werden. Klicken Sie hier für weitere Informationen.',
      documentVersionIsRejected: 'Eine Version dieses Dokumentes wurde abgelehnt. Für weitere Informationen klicken Sie bitte hier.',
      emptyTimeline: 'Dieses Dokument hat noch keine gültige Version',
      noPastDocument: 'Keine Archive für dieses Dokument vorhanden',
      noPresentDocument: 'Keine aktuelle Dokumentversion vorhanden',
      noPresentDocumentAtDate: 'Keine Dokumentversion vorhanden am Startdatum des Projektes: %{projectOpeningDate}',
      noPresentDocumentAtInterventionDate: 'Keine gültige Version zum Zeitpunkt des Beginns der Projektintervention: %{interventionDate}',
      noPresentDocumentAtInterventionDateTooltip: 'Der Status wird auf der Grundlage des Startdatums der Projektintervention berechnet, da diese Firma nach dem Datum der Projekteröffnung gegründet wurde.',
      showArchives: 'Archive für dieses Dokument anzeigen',
      showTimelineButton: 'Alle gültigen Versionen anzeigen',
      state: {
        ALMOST_EXPIRED: 'Ungültig %{time}',
        AWAITING_COMPLETION: 'Unvollständig',
        AWAITING_GATHERING: 'Erfassung ausstehend',
        AWAITING_SIGNATURE: 'Unterschrift ausstehend',
        AWAITING_VALIDATION: 'Wird geprüft',
        CREATED: 'Unbekannt',
        EXPIRED: 'Ungültig seit %{time}',
        MISSING: 'Fehlt',
        NOT_APPLICABLE: 'nicht zutreffend',
        REJECTED: 'Abgelehnt',
        SIGNED: 'Signiert, gültig %{until}',
        VALID: 'Gültig %{until}'
      },
      timeline: 'Zeitleiste der Dokumentversionen',
      unpublished: 'Archiviertes Dokument',
      validityEndLineForValid: ' bis %{validityEnd}'
    },
    documentType: 'Dokumententyp',
    documentVersion: {
      ongoingLabel: 'Aktuell',
      rejectionReason: ' Grund: <span class="error">%{rejectionReason}</span>',
      state: {
        ALMOST_EXPIRED: '<strong class="success">gültig</strong>',
        AWAITING_GATHERING: '<strong class="ofa">wird abgerufen</strong>',
        AWAITING_SIGNATURE: '<strong class="error">warten auf Signatur</strong>',
        AWAITING_VALIDATION: '<strong class="ofa">wird geprüft</strong>',
        EXPIRED: '<strong class="success">gültig</strong>',
        MISSING: '<strong class="error">fehlt</strong>',
        NOT_APPLICABLE: '<strong class="information">nicht zutreffend</strong>',
        REJECTED: '<strong class="error">abgelehnt</strong>.',
        SIGNED: '<strong class="success">signiert und geprüft</strong>',
        VALID: '<strong class="success">gültig</strong>'
      },
      stateLine: {
        CURRENT: 'Diese Version des Dokuments ist %{state}',
        FUTURE: 'Diese Version des Dokuments ist %{state}',
        PAST: 'Diese Version des Dokuments war %{state}'
      },
      validityEndLine: ' bis <strong>%{validityEnd}</strong>',
      validityFullLine: ' zwischen <strong>%{validityStart}</strong> und <strong>%{validityEnd}</strong>',
      validityStartLine: ' von <strong>%{validityStart}</strong>'
    },
    dossierResume: {
      documentAlmostExpiredText: 'Folgendes Dokument ist bald ungültig:',
      documentInvalidInProgressText: 'Ein Dokument wird derzeit von OnceForAll geprüft.',
      documentInvalidText: 'Bitte bearbeiten Sie folgende Dokumente: ',
      documentsAlmostExpiredText: 'Folgende Dokumente sind bald ungültig:',
      documentsInvalidsInProgressText: 'Dokumente werden derzeit von OnceForAll geprüft.',
      documentsInvalidsText: 'Bitte bearbeiten Sie folgende Dokumente: ',
      download: 'Nachweisstatus herunterladen',
      title: {
        AWAITING_VERIFICATION: 'Ihr Nachweisordner wird geprüft',
        INVALID: 'Ihr Nachweisordner ist unvollständig',
        VALID: 'Ihr Nachweisordner ist vollständig',
        WARNING: 'Ihr Nachweisordner ist vollständig aber bald ungültig'
      }
    },
    downloadExcelTemplate: 'Excel-Vorlage herunterladen',
    downloadExcelTemplateMessage: 'Laden Sie zuerst die Excel-Vorlage herunter',
    downloadTemplate: 'Vorlage herunterladen',
    downloadTemplateMessage: 'Laden Sie zuerst die Vorlage herunter',
    dragDropHere: 'Hier ablegen',
    duplicate: 'Duplizieren',
    editAdditionalDesignation: 'Zusatzbezeichnung bearbeiten',
    errorMaxSizeMessage: 'Max. %{count}MB',
    errorMinSizeMessage: 'Min. %{count}KB',
    errorTypeMessage: 'Ausschließlich folgende Dateiformate sind akzeptiert: ',
    fileSize: 'Dateigröße',
    filename: 'Dateiname',
    foreignEmployees: {
      secondaryUploadMessage: 'Verfügbare Formate: Excel und PDF (wenn Sie ein PDF hochladen, wird OnceForAll die Liste in Excel übertragen und für Sie einstellen)',
      uploadMessage: {
        bullet1: 'Angestellte aus Ländern des Europäischen Wirtschaftsraums',
        bullet2: 'Leiharbeiter',
        line1: 'Nicht zutreffend für:',
        line2: 'Diese Informationen werden von OnceForAll überprüft.\nBitte vergewissern Sie sich von der Richtigkeit und Lesbarkeit Ihrer Angaben.'
      }
    },
    header: {
      dossiers: 'Kategorie',
      name: 'Name',
      reminderStatus: 'Nachfass-Status',
      status: 'Status',
      validityPeriod: 'Gültig von - bis'
    },
    issueDate: 'Ausstellungsdatum',
    myArchivedDocuments: 'Archive',
    myDocuments: 'Nachweise',
    myTodoDocuments: 'To Do',
    noArchive: 'Keine Archive vorhanden',
    noDocumentMessage: 'Bitte fügen Sie mindestens einen Kunden hinzu um Dokumente einstellen zu können.',
    noForeignWorkers: 'Ich habe keine ausländischen Arbeitnehmer.',
    noResultMatch: 'Kein Nachweis entspricht Ihrer Suche',
    noSignPermission: 'Nur der gesetzliche Vertreter der Organisation kann dieses Dokument unterschreiben.',
    noTodo: 'Sie haben kein Dokument zu auswählen',
    notDepositor: 'Bitte wenden Sie sich an den Kundendienst, um den Einzahlerservice bei dieser Organisation zu aktivieren.',
    open: 'Anzeigen',
    openExcel: 'Excel-Datei herunterladen',
    openProof: 'Authentifizierung herunterladen',
    payrollRatio: {
      NC: 'Nicht berichtet',
      label: 'Lohnsummenquote:'
    },
    planUpgradable: 'Um Ihren Nachweisordner zu aktivieren, wählen Sie bitte unser Professional-Paket.',
    remind: {
      additionalContext: 'Zusätzlicher Kontext',
      command: {
        title: 'Nachfordern'
      },
      context: 'Kontext',
      description: {
        additionalContext: 'Zusätzlicher Kontext:',
        dateFrom: 'Nachfassen terminiert am %{date}',
        emptyMessage: 'Keine Erinnerung zu zeigen',
        projectName: 'Bezeichnung:',
        reason: {
          APPLICATION_APPROVAL: 'Zulassungsantrag',
          CONTRACT: 'Vertrag',
          CREATION_ADDITIONAL_DOCUMENT: 'Erstellen eines zusätzlichen Dokumentes',
          END_OF_PROJECT: 'Projektende',
          PAYMENT: 'Zahlung',
          PRIVATE_MARKET: 'Privater Markt',
          PUBLIC_MARKET: 'Öffentlicher Markt',
          REPORT_ANOMALY: 'Auffälligkeit melden',
          SIGNATURE: 'Unterschrift',
          title: 'Grund:'
        }
      },
      documents: {
        error: 'Sie müssen ein Dokument auswählen',
        title: 'Nachzufordernde Dokumente'
      },
      information: 'Falls der Nachweisordner Ihres NU trotz unserer regelmässigen Benachrichtigungen per E-Mail und Telefon nicht vollständig ist, können Sie uns hier beauftragen, in Ihrem Namen und bezüglich des unten anzugebenden Kontextes fehlende Dokumente telefonisch nachzufordern.<br /><br />Wir informieren Sie persönlich über das Ergebnis unserer Bemühungen.',
      reason: {
        APPLICATION_APPROVAL: 'Zulassungsantrag',
        CONTRACT: 'Vertrag',
        CREATION_ADDITIONAL_DOCUMENT: 'Erstellen eines zusätzlichen Dokumentes',
        PAYMENT: 'Zahlung',
        REPORT_ANOMALY: 'Auffälligkeit melden',
        SIGNATURE: 'Unterschrift',
        name: 'Grund'
      },
      subMessageProject: 'Bezeichnung',
      subMessageReason: 'Grund',
      success: 'Die spezifische Nachforderung wurde angelegt. Sie erhalten eine Kopie der E-Mail.',
      title: 'Spezifisches Dokument anfordern'
    },
    searchArchiveBar: 'Archive name',
    searchBar: 'Nachweisbezeichnung',
    seeExample: 'Beispiel ansehen',
    sign: 'Unterschreiben',
    signWaitingText: 'Bitte warten! Sie werden zu unserem E-Signatur-Partner weitergeleitet.',
    staff: 'Mitarbeiter:',
    state: {
      ALMOST_EXPIRED: 'Bald ungültig',
      AWAITING_COMPLETION: 'Unvollständig',
      AWAITING_GATHERING: 'Erfassung ausstehend',
      AWAITING_SIGNATURE: 'Unterschrift ausstehend',
      AWAITING_VALIDATION: 'Wird geprüft',
      CREATED: 'Unbekannt',
      EXPIRED: 'Ungültig',
      MISSING: 'Fehlt',
      NOT_APPLICABLE: 'nicht zutreffend',
      REJECTED: 'Abgelehnt',
      SIGNED: 'Unterschrieben',
      VALID: 'Geprüft'
    },
    upload: 'Auswählen',
    uploadMessage: {
      FRANCE: 'Wenn Ihr Dokument nicht auf Französisch vorliegt, stellen Sie bitte das Original und seine Übersetzung ein.',
      GERMANY: 'Wenn Ihr Dokument nicht auf Deutsch vorliegt, stellen Sie bitte das Original und seine Übersetzung ein.'
    },
    uploadSuccess: 'Upload erfolgreich beendet.',
    uploadUpdate: 'Aktualisieren',
    valid: 'Gültig',
    validityPeriod: 'Vom %{startDate} bis %{endDate}',
    waiting: 'NU-Aktion erwartet'
  },
  documentType: {
    search: {
      alreadyRequired: 'Dieses Dokument wird für dieses Projekt bereits angefordert.',
      notfound: 'Dieser Dokumententyp existiert nicht.',
      placeholder: 'Suche'
    }
  },
  dossier: {
    add: 'Dokument hinzufügen',
    addLabel: 'Dokument auswählen',
    addSuccessful: 'Das Dokument wurde hinzugefügt',
    countryLabel: 'Ordner ',
    download: {
      all: 'Ordner speichern',
      dossierOverview: 'Nachweisübersicht herunterladen',
      standard: 'Standard Ordner speichern',
      standardArchives: 'Alle Archive herunterladen'
    },
    interoperated: 'Externer Ordner',
    labels: {
      ADDITIONAL: 'Zusätzlich',
      BUSINESS: {
        ALL: 'Geschäftsbereich',
        CLEANING: 'Reinigungsdienste',
        CONSTRUCTION: 'Baugewerbe',
        SAFETY: 'Sicherheit',
        TEMPORARY_WORK: 'Zeitarbeit',
        TRANSPORTATION: 'Transport'
      },
      LEGAL: 'Standard',
      PROJECT: 'Projekte'
    },
    print: {
      all: 'Ordner drucken',
      standard: 'Standard Ordner drucken'
    },
    projects: 'Projekte',
    relatedProjects: 'Ähnliche Projekte',
    state: {
      AWAITING_VERIFICATION: {
        fullLabel: 'Nachweisordner wird geprüft',
        shortLabel: 'Wird geprüft'
      },
      DEPOSITOR_SERVICE_DEACTIVATED: {
        fullLabel: 'Dokumentenservice deaktiviert',
        shortLabel: 'Dokumentenservice deaktiviert'
      },
      EMPTY: {
        fullLabel: 'Kein Dokument für das ausgewählte Land',
        shortLabel: 'Kein Dokument'
      },
      INVALID: {
        fullLabel: 'Unvollständiger Nachweisordner',
        shortLabel: 'Unvollständig'
      },
      UNKNOWN: {
        fullLabel: 'Der Nachweisordner ist noch nicht verfügbar',
        shortLabel: 'Nicht verfügbar'
      },
      VALID: {
        fullLabel: 'Vollständiger Nachweisordner',
        shortLabel: 'Vollständig'
      },
      WARNING: {
        fullLabel: 'Nachweisordner bald ungültig',
        shortLabel: 'Bald ungültig'
      },
      title: 'Nachweisordner-Status'
    }
  },
  error: {
    CGURequired: 'Die AGB müssen akzeptiert werden',
    clientAlreadyExists: 'Es kann nur 1 Kunde ausgewählt werden. Bitte korrigieren Sie Ihre Auswahl.',
    dateShouldBeBefore: 'Es wurde ein Termin für den Beginn der Intervention festgelegt, der vor dem Termin der Eröffnung des neuen Projekts liegt!',
    emailConfirmation: 'E-Mail-Adresse stimmt nicht überein',
    generic: 'Ein Fehler ist aufgetreten.',
    interventionAlreadyEnded: 'Sie sind in diesem Projekt bereits mit dieser Firma verbunden',
    invalidEmailFormat: 'Das Format Ihrer E-Mail-Adresse ist ungültig, bitte ändern Sie diese',
    invalidIdentificationNumber: 'Ungültige Umsatzsteuer-Identifikationsnummer',
    invalidMobilePhoneNumber: 'Das Format Ihrer Telefonnummer ist ungültig. Bitte korrigieren.',
    invalidNumberFormat: 'Dieses Feld muss Zahlen enthalten',
    invalidPhoneNumber: 'Das Format Ihrer Telefonnummer ist ungültig, bitte ändern Sie diese',
    invalidRegistrationNumber: 'Ungültige Registrationsnummer',
    notYetSupported: 'Wird noch nicht unterstützt.',
    organisationAlreadyExists: 'Sie sind in diesem Projekt bereits mit dieser Firma verbunden',
    organisationNotFound: 'Es ist noch keine Firma mit dieser Betriebsnummer angemeldet',
    passwordConfirmation: 'Paßwort stimmt nicht überein',
    privacyPolicyRequired: 'Die Datenschutzerklärung muss akzeptiert werden',
    required: 'Diese Angabe ist Pflicht.',
    userAlreadyExist: 'Es gibt bereits ein Nutzerkonto mit dieser E-Mail-Adresse.',
    validation: 'Diese Angabe ist Pflicht.'
  },
  errorPage: {
    contactEmail: 'kontakt.de@onceforall.com',
    buttonLabel: 'Seite neu laden',
    subtitle: 'Entschuldigung. Auf unserer Seite gab es einen Fehler, den wir derzeit beheben.',
    text: 'Wenn das Problem weiterhin besteht, können Sie uns wie folgt erreichen ',
    title: 'Fehler'
  },
  favoriteRelationship: {
    add: 'Zu Favoriten hinzufügen',
    message: {
      add: '%{organisationName} wurde zu den Favoriten hinzugefügt.',
      remove: '%{organisationName} wurde von den Favoriten entfernt.'
    },
    remove: 'Von Favoriten entfernen'
  },
  globalDashboard: {
    documents: 'Nachweise meiner Nachunternehmer',
    documentsStillValid: 'Noch gültig',
    myOrganisations: 'Meine Firmen',
    mySubcontractors: 'Meine Nachunternehmer',
    organisationRegistrationSuccessful: {
      line1: 'Ihre Anfrage wird bearbeitet.',
      line2: 'Wir benachrichtigen Sie per E-Mail, wenn die Bearbeitung Ihrer Anfrage abgeschlossen ist.'
    },
    quitus: 'Nachweisübersicht meiner Nachunternehmer',
    quitusDescription: 'der Nachunternehmer haben eine gültige Nachweisübersicht',
    seeAllSubcontractors: 'Alle aktiver Nachunternehmer anzeigen',
    subcontractorsLabel: 'Aktiver Nachunternehmer'
  },
  globalSubcontractor: {
    noSubcontractors: 'Keine Nachunternehmer',
    selectClientForSubcontractor: 'Meine Firmen in Verbindung mit dem NU %{subcontractorName}:',
    title: 'Alle meine Nachunternehmer'
  },
  helpCenter: {
    aQuestion: 'Sie haben Fragen?',
    category: {
      ACCESS: 'Mein Zugang',
      CLIENT: 'Meine Kunden',
      DOCUMENT: 'Meine Nachweise',
      MODEL: 'Meine Nachweisbeispiele',
      OPTION: 'Meine Optionen',
      PARAMETER: 'Meine Einstellungen',
      PROJECT: 'Meine Projekte',
      SUBCONTRACTOR: 'Meine Nachunternehmer'
    },
    contactCustomerService: 'Sie konnten Ihre Frage nicht beantworten? Dann wenden Sie sich',
    contactCustomerServiceLink: 'bitte an unseren Kundendienst.',
    helpCenterButton: 'Hilfe und Support',
    selectACategory: 'Kategorie auswählen:',
    title: 'Hilfe und Support'
  },
  identificationNumber: {
    ANDORRA: {
      REGISTRATION_NUMBER: {
        name: 'TVA intracommunautaire',
        tooltip: 'FR + 11-ziffrige Zahl'
      },
      VAT_IDENTIFICATION_NUMBER: {
        name: 'TVA intracommunautaire (USt-IdNr)',
        tooltip: 'FR + 11-ziffrige Zahl'
      }
    },
    AUSTRIA: {
      REGISTRATION_NUMBER: {
        name: 'Umsatzsteuer-Identifikationsnummer',
        tooltip: 'ATU + 8-ziffrige Zahl'
      },
      VAT_IDENTIFICATION_NUMBER: {
        name: 'Umsatzsteuer-Identifikationsnummer',
        tooltip: 'ATU + 8-ziffrige Zahl'
      }
    },
    BELGIUM: {
      REGISTRATION_NUMBER: {
        name: 'BTW identificatienummer / Numéro de TVA',
        tooltip: 'BE + 10-ziffrige Zahl'
      },
      VAT_IDENTIFICATION_NUMBER: {
        name: 'BTW identificatienummer / Numéro de TVA (USt-IdNr)',
        tooltip: 'BE + 10-ziffrige Zahl'
      }
    },
    BOLIVIA: {
      REGISTRATION_NUMBER: {
        name: 'Número de Identificación Tributaria',
        tooltip: '8 bis 12-ziffrige Zahl'
      },
      VAT_IDENTIFICATION_NUMBER: {
        name: 'Número de Identificación Tributaria (USt-IdNr)',
        tooltip: '8 bis 12-ziffrige Zahl'
      }
    },
    BULGARIA: {
      REGISTRATION_NUMBER: {
        name: 'Identifikacionen nomer po DDS',
        tooltip: 'BG + 9 oder 10-ziffrige Zahl'
      },
      VAT_IDENTIFICATION_NUMBER: {
        name: 'Identifikacionen nomer po DDS (USt-IdNr)',
        tooltip: 'BG + 9 oder 10-ziffrige Zahl'
      }
    },
    CROATIA: {
      REGISTRATION_NUMBER: {
        name: 'PDV Id. Broj OIB',
        tooltip: 'HR + 11-ziffrige Zahl'
      },
      VAT_IDENTIFICATION_NUMBER: {
        name: 'PDV Id. Broj OIB (USt-IdNr)',
        tooltip: 'HR + 11-ziffrige Zahl'
      }
    },
    CZECH_REPUBLIC: {
      REGISTRATION_NUMBER: {
        name: 'Daňové identifikační číslo',
        tooltip: 'CZ + 8 bis 10-ziffrige Zahl'
      },
      VAT_IDENTIFICATION_NUMBER: {
        name: 'Daňové identifikační číslo (USt-IdNr)',
        tooltip: 'CZ + 8 bis 10-ziffrige Zahl'
      }
    },
    DENMARK: {
      REGISTRATION_NUMBER: {
        name: 'Momsregistreringsnummer',
        tooltip: 'DK + 8-ziffrige Zahl'
      },
      VAT_IDENTIFICATION_NUMBER: {
        name: 'Momsregistreringsnummer (USt-IdNr)',
        tooltip: 'DK + 8-ziffrige Zahl'
      }
    },
    ESTONIA: {
      REGISTRATION_NUMBER: {
        name: 'Käibemaksukohustuslase number',
        tooltip: 'EE + 9-ziffrige Zahl'
      },
      VAT_IDENTIFICATION_NUMBER: {
        name: 'Käibemaksukohustuslase number (USt-IdNr)',
        tooltip: 'EE + 9-ziffrige Zahl'
      }
    },
    FRANCE: {
      GROUP_NUMBER: {
        name: 'SIREN',
        tooltip: '9-ziffrige Zahl'
      },
      REGISTRATION_NUMBER: {
        name: 'SIRET',
        tooltip: '14-ziffrige Zahl'
      },
      VAT_IDENTIFICATION_NUMBER: {
        name: 'TVA intracommunautaire (USt-IdNr)',
        tooltip: 'FR + 11-ziffrige Zahl'
      }
    },
    GERMANY: {
      REGISTRATION_NUMBER: {
        name: 'Betriebsnummer',
        tooltip: '8-ziffrige Zahl'
      },
      STEUERLICHE_IDENTIFIKATIONSNUMMER: {
        name: 'Steuerliche Identifikationsnummer',
        shortName: 'Steuernummer',
        tooltip: '11-ziffrige Zahl'
      },
      VAT_IDENTIFICATION_NUMBER: {
        name: 'Umsatzsteuer-Identifikationsnummer',
        shortName: 'Ust.-ID',
        tooltip: 'DE + 9-ziffrige Zahl'
      }
    },
    GREECE: {
      REGISTRATION_NUMBER: {
        name: 'Arithmós Forologikou Mētrṓou',
        tooltip: 'EL + 9-ziffrige Zahl'
      },
      VAT_IDENTIFICATION_NUMBER: {
        name: 'Arithmós Forologikou Mētrṓou (USt-IdNr)',
        tooltip: 'EL + 9-ziffrige Zahl'
      }
    },
    HUNGARY: {
      REGISTRATION_NUMBER: {
        name: 'Közösségi adószám',
        tooltip: 'HU + 8-ziffrige Zahl'
      },
      VAT_IDENTIFICATION_NUMBER: {
        name: 'Közösségi adószám (USt-IdNr)',
        tooltip: 'HU + 8-ziffrige Zahl'
      }
    },
    ICELAND: {
      REGISTRATION_NUMBER: {
        name: 'Virðisaukaskattsnúmer',
        tooltip: 'IS + 6-ziffrige Zahl'
      },
      VAT_IDENTIFICATION_NUMBER: {
        name: 'Virðisaukaskattsnúmer (USt-IdNr)',
        tooltip: 'IS + 6-ziffrige Zahl'
      }
    },
    INDIA: {
      REGISTRATION_NUMBER: {
        name: 'Value Added Tax / Central Sales Tax TIN',
        tooltip: 'IN + 11-ziffrige Zahl + V'
      },
      VAT_IDENTIFICATION_NUMBER: {
        name: 'Value Added Tax / Central Sales Tax TIN (USt-IdNr)',
        tooltip: 'IN + 11-ziffrige Zahl + V'
      }
    },
    ITALY: {
      REGISTRATION_NUMBER: {
        name: 'Codice Fiscale',
        tooltip: '"11-digit number for companies or 16-digit code for individuals"'
      },
      VAT_IDENTIFICATION_NUMBER: {
        name: 'Partita IVA (USt-IdNr)',
        tooltip: 'IT + 11-ziffrige Zahl'
      }
    },
    IVORY_COAST: {
      REGISTRATION_NUMBER: {
        name: 'VAT Identification Number',
        tooltip: 'CI + 9-ziffrige Zahl'
      },
      VAT_IDENTIFICATION_NUMBER: {
        name: 'VAT Identification Number (USt-IdNr)',
        tooltip: 'CI + 9-ziffrige Zahl'
      }
    },
    LATVIA: {
      REGISTRATION_NUMBER: {
        name: 'Pievienotās vērtības nodokļa (PVN) reģistrācijas numurs',
        tooltip: 'LV + 11-ziffrige Zahl'
      },
      VAT_IDENTIFICATION_NUMBER: {
        name: 'Pievienotās vērtības nodokļa (PVN) reģistrācijas numurs (USt-IdNr)',
        tooltip: 'LV + 11-ziffrige Zahl'
      }
    },
    LITHUANIA: {
      REGISTRATION_NUMBER: {
        name: 'PVM (Pridėtinės vertės mokestis) mokėtojo kodas',
        tooltip: 'LT + 9 oder 12-ziffrige Zahl'
      },
      VAT_IDENTIFICATION_NUMBER: {
        name: 'PVM (Pridėtinės vertės mokestis) mokėtojo kodas (USt-IdNr)',
        tooltip: 'LT + 9 oder 12-ziffrige Zahl'
      }
    },
    LUXEMBOURG: {
      REGISTRATION_NUMBER: {
        name: 'Numéro d‘identification à la TVA',
        tooltip: 'LU + 8-ziffrige Zahl'
      },
      VAT_IDENTIFICATION_NUMBER: {
        name: 'Numéro d‘identification à la TVA (USt-IdNr)',
        tooltip: 'LU + 8-ziffrige Zahl'
      }
    },
    MAURITIUS: {
      REGISTRATION_NUMBER: {
        name: 'VAT Identification Number',
        tooltip: 'MU + 8-ziffrige Zahl'
      },
      VAT_IDENTIFICATION_NUMBER: {
        name: 'VAT Identification Number (USt-IdNr)',
        tooltip: 'MU + 8-ziffrige Zahl'
      }
    },
    MEXICO: {
      REGISTRATION_NUMBER: {
        name: 'Registro Federal de Contribuyentes',
        tooltip: '3 oder 4-character + 6-digit + 3-character Zahl'
      },
      VAT_IDENTIFICATION_NUMBER: {
        name: 'Registro Federal de Contribuyentes (USt-IdNr)',
        tooltip: '3 oder 4-character + 6-digit + 3-character Zahl'
      }
    },
    MONACO: {
      REGISTRATION_NUMBER: {
        name: 'TVA intracommunautaire',
        tooltip: 'FR + 11-ziffrige Zahl'
      },
      VAT_IDENTIFICATION_NUMBER: {
        name: 'TVA intracommunautaire (USt-IdNr)',
        tooltip: 'FR + 11-ziffrige Zahl'
      }
    },
    NETHERLANDS: {
      REGISTRATION_NUMBER: {
        name: 'Btw-nummer',
        tooltip: 'NL + 9-ziffrige + B + 2-ziffrige'
      },
      VAT_IDENTIFICATION_NUMBER: {
        name: 'Btw-nummer (USt-IdNr)',
        tooltip: 'NL + 9-ziffrige + B + 2-ziffrige'
      }
    },
    POLAND: {
      REGISTRATION_NUMBER: {
        name: 'Numer identyfikacji podatkowej',
        tooltip: 'PL + 10-ziffrige Zahl'
      },
      VAT_IDENTIFICATION_NUMBER: {
        name: 'Numer identyfikacji podatkowej (USt-IdNr)',
        tooltip: 'PL + 10-ziffrige Zahl'
      }
    },
    PORTUGAL: {
      REGISTRATION_NUMBER: {
        name: 'Número de Identificação Fiscal / de Pessoa Coletiva',
        tooltip: 'PT + 9-ziffrige Zahl'
      },
      VAT_IDENTIFICATION_NUMBER: {
        name: 'Número de Identificação Fiscal / de Pessoa Coletiva (USt-IdNr)',
        tooltip: 'PT + 9-ziffrige Zahl'
      }
    },
    ROMANIA: {
      REGISTRATION_NUMBER: {
        name: 'Codul de identificare fiscală',
        tooltip: 'RO + 2 bis 10-ziffrige Zahl'
      },
      VAT_IDENTIFICATION_NUMBER: {
        name: 'Codul de identificare fiscală (USt-IdNr)',
        tooltip: 'RO + 2 bis 10-ziffrige Zahl'
      }
    },
    SERBIA: {
      REGISTRATION_NUMBER: {
        name: 'Poreski identifikacioni broj',
        tooltip: '9-ziffrige Zahl'
      },
      VAT_IDENTIFICATION_NUMBER: {
        name: 'Poreski identifikacioni broj (USt-IdNr)',
        tooltip: '9-ziffrige Zahl'
      }
    },
    SLOVAKIA: {
      REGISTRATION_NUMBER: {
        name: 'Identifikačné číslo pre daň z pridanej hodnoty',
        tooltip: 'SK + 10-ziffrige Zahl'
      },
      VAT_IDENTIFICATION_NUMBER: {
        name: 'Identifikačné číslo pre daň z pridanej hodnoty (USt-IdNr)',
        tooltip: 'SK + 10-ziffrige Zahl'
      }
    },
    SLOVENIA: {
      REGISTRATION_NUMBER: {
        name: 'Identifikacijska številka za DDV',
        tooltip: 'SI + 8-ziffrige Zahl'
      },
      VAT_IDENTIFICATION_NUMBER: {
        name: 'Identifikacijska številka za DDV (USt-IdNr)',
        tooltip: 'SI + 8-ziffrige Zahl'
      }
    },
    SPAIN: {
      REGISTRATION_NUMBER: {
        name: 'Número de Identificación Fiscal',
        tooltip: 'ES + 1 character + 7 ziffrige + 1 character Zahl'
      },
      VAT_IDENTIFICATION_NUMBER: {
        name: 'Número de Identificación Fiscal (USt-IdNr)',
        tooltip: 'ES + 1 character + 7 ziffrige + 1 character Zahl'
      }
    },
    SWEDEN: {
      REGISTRATION_NUMBER: {
        name: 'Momsregistreringsnummer',
        tooltip: 'SE + 12-ziffrige Zahl'
      },
      VAT_IDENTIFICATION_NUMBER: {
        name: 'Momsregistreringsnummer (USt-IdNr)',
        tooltip: 'SE + 12-ziffrige Zahl'
      }
    },
    SWITZERLAND: {
      REGISTRATION_NUMBER: {
        name: 'Mehrwertsteuernummer',
        tooltip: 'CHE + 9-ziffrige'
      },
      VAT_IDENTIFICATION_NUMBER: {
        name: 'Mehrwertsteuernummer (USt-IdNr)',
        tooltip: 'CHE + 9-ziffrige'
      }
    },
    UNITED_KINGDOM: {
      REGISTRATION_NUMBER: {
        name: 'Value added tax registration number',
        tooltip: 'GB + 9 oder 12-ziffrige / GBGD + 3-ziffrige / GBHA + 3-ziffrige'
      },
      VAT_IDENTIFICATION_NUMBER: {
        name: 'Value added tax registration number (USt-IdNr)',
        tooltip: 'GB + 9 oder 12-ziffrige / GBGD + 3-ziffrige / GBHA + 3-ziffrige'
      }
    }
  },
  initialLoading: {
    error: 'Wir entschuldigen Sie für die Verzögerung.  Unsere Entwickler werden das Problem analysieren.',
    message: 'Einen Moment bitte, OnceForAll beginnt...'
  },
  intervention: {
    dateForm: {
      error: 'Das Datum darf nicht vor dem Datum der Eröffnung des Projekts liegen',
      fieldLabel: 'Datum',
      openButton: 'Geben Sie ein Datum für den Einsatz an',
      saveSuccess: 'Das Datum für den Beginn der Projektintervention wurde festgelegt',
      title: 'Geben Sie ein Datum für den Einsatz an'
    },
    ended: {
      buttonTitle: 'Beteiligung dieser Firma beenden',
      confirmEndOrganisation: {
        content: 'Sind Sie sicher, daß Sie die Beteiligung von %{organisationName} an diesem Projekt beenden wollen?',
        warning: 'Diese Firma und ihre Nachunternehmer werden nicht mehr auf das Projekt zugreifen können.'
      },
      endSuccess: '%{organisationName} ist nicht mehr an dem Projekt beteiligt.',
      name: ' (beendet)',
      tooltip: 'Die Beteiligung an diesem Projekt wurde am %{endDate} beendet.'
    },
    invited: {
      external: {
        CLIENT: 'Kundenanmeldung ausstehend',
        GENERAL_CONTRACTOR: 'GU-Anmeldung ausstehend',
        PROJECT_MANAGER: 'Projektentwickleranmeldung ausstehend',
        PROJECT_MANAGER_CLIENT: 'Dienstleisteranmeldung ausstehend',
        SERVICE_PROVIDER: 'Dienstleisteranmeldung ausstehend',
        SUB_CONTRACTOR: 'NU-Anmeldung ausstehend'
      },
      internal: {
        CLIENT: 'Annahme durch Kunden ausstehend',
        GENERAL_CONTRACTOR: 'Annahme durch Generalunternehmer ausstehend',
        PROJECT_MANAGER: 'Annahme durch Projektentwickler ausstehend',
        PROJECT_MANAGER_CLIENT: 'Annahme durch Projektentwickler ausstehend',
        SERVICE_PROVIDER: 'Annahme durch Dienstleister ausstehend',
        SUB_CONTRACTOR: 'Annahme durch NU ausstehend'
      }
    },
    organisationDeactivated: '(Deaktivierte Firma)',
    removed: {
      removeSuccess: '%{organisationName} wurde entfernt'
    },
    role: {
      CLIENT: 'Kunde',
      GENERAL_CONTRACTOR: 'Generalunternehmer',
      PROJECT_MANAGER: 'Projektentwickler',
      PROJECT_MANAGER_CLIENT: 'Projektentwickler',
      SERVICE_PROVIDER: 'Dienstleister',
      SUB_CONTRACTOR: 'Nachunternehmer'
    }
  },
  invalidOrganisationDocuments: {
    emptyMessage: 'Keine fehlenden und veralteten Dokumente.',
    title: 'Ungültige Dokumente'
  },
  invitation: {
    externalInvitationSuccessTitle: 'Einladung versandt!',
    received: {
      actions: {
        accept: 'Diese Einladung annehmen',
        reject: 'Diese Einladung ablehnen'
      },
      emptyList: 'Sie haben keine Einladungen zu bearbeiten',
      expandList: 'Alle Einladungen anzeigen',
      message: {
        PROJECT_NOT_AUTOMATICALLY_ACCEPTED: 'Sie wurden in das OnceForAll-Projekt __s%{projectName}__s eingeladen.',
        RELATIONSHIP_NOT_AUTOMATICALLY_ACCEPTED: 'Sie wurden als Nachunternehmer in das OnceForAll-Netzwerk von __s%{invitingOrganisationName}__s eingeladen.',
        RELATIONSHIP_SUGGESTED: 'Als Nachunternehmer könnten Sie daran interessiert sein, Ihre Dokumente mit __s%{invitingOrganisationName}__s zu teilen.',
        USER_PENDING: '__s%{firstName} %{lastName}__s möchte Ihrer OFA-Organisation beitreten.',
        projectInvitedBy: 'Eingeladen von __s%{invitingOrganisationName}__s'
      },
      title: 'Erhaltene Einladungen'
    },
    sent: {
      clone: 'Die vom Benutzer registrierte Organisation %{cloneRegistrationNumber} folgt Ihrer Einladung an die Organisation %{originalRegistrationNumber}',
      email: 'E-Mail-Adresse',
      invitationDate: 'Eingangsdatum',
      invitationSentDate: 'Absendedatum',
      noResult: 'Keine Einladung zur Ausstellung',
      resentOn: 'Neu versandt am %{date}',
      status: 'Status',
      waitingForApproval: 'Annahme durch NU ausstehend',
      waitingForRegistration: {
        client: 'Kundenanmeldung ausstehend',
        subcontractor: 'NU-Anmeldung ausstehend'
      }
    },
    suggestion: {
      accept: 'Sie werden Ihre Dokumente mit teilen',
      actions: {
        accept: 'Sie werden Ihre Dokumente mit %{invitingOrganisationName} teilen',
        reject: 'Sie möchten Ihre Dokumente nicht mit %{invitingOrganisationName} teilen'
      },
      expandList: 'Alle Vorschläge anzeigen',
      reject: 'Sie möchten Ihre Dokumente nicht mit teilen',
      rejectionReason: 'Wählen Sie einen Grund für die Ablehnung des Vorschlags',
      rejectionSuccess: '[%{invitingOrganisationName} has been removed from your clients suggestions!]',
      title: 'Die Vorschläge basieren auf Einladungen, die Sie per E-Mail erhalten haben, die aber eine andere Firma als Ihre einladen'
    }
  },
  invite: {
    alreadyExists: {
      action: 'Hinzufügen',
      text: 'Sie können jetzt hinzufügen',
      title: 'Diese Firma ist bereits im OnceForAll-Netzwerk registriert'
    },
    alreadyInvited: {
      text: 'Sie haben bereits eine Einladung an diese E-Mail-Adresse geschickt, damit diese Firma in das OnceForAll-Netzwerk aufgenommen wird.',
      title: 'Diese Einladung existiert bereits'
    },
    cancel: 'Einladung löschen',
    cancelSuccessful: 'Die Einladung wurde gelöscht.',
    customMessage: 'Nachricht',
    email: 'E-Mail-Adresse',
    firstName: 'Vorname',
    inactive: {
      text: 'Bitte wenden Sie für weitere Informationen an den Kundendienst.',
      title: 'Diese Firma ist deaktiviert'
    },
    language: 'Sprache',
    lastName: 'Name',
    messageSectionSubtitle: 'Sie können die vorausgefüllte Nachricht beibehalten oder sie ändern',
    messageSectionTitle: 'Nachricht der Einladung',
    organisationName: 'Firma (Niederlassung)',
    organisationSectionTitle: 'Welche Firma würden Sie gerne einladen?',
    phoneNumber: 'Telefonnummer',
    unknown: {
      text: 'Sie können ihn einladen, dem OnceForAll-Netzwerk beizutreten.',
      title: 'Es gibt keine Firma mit dieser Betriebsnummer'
    },
    userSectionTitle: 'An wen sollten wir diese Einladung richten?'
  },
  invoices: {
    amountDue: 'Fälliger Betrag',
    amountTotal: 'Gesamt',
    creationDate: 'Ausgestellt am %{date}',
    download: 'Rechnung herunterladen',
    dueOn: 'Fällig am %{date}',
    loadMore: 'Nächste 10 Rechnungen anzeigen',
    noResult: 'Keine Rechnung zu zeigen',
    paidOn: 'Bezahlt am %{date}',
    sentTo: 'Rechnungsadresse',
    status: {
      NOT_PAID: 'Offen',
      PAID: 'Bezahlt',
      PAYMENT_DUE: 'Offen',
      POSTED: 'Offen'
    },
    statusTitle: 'Status',
    title: 'Rechnungen'
  },
  language: {
    de: 'Deutsch',
    en: 'English',
    fr: 'Français',
    it: 'Italiano'
  },
  mandate: {
    details: {
      backToList: 'Zurück zur Mandatsliste',
      details: {
        certifyingThirdParty: 'Zertifizierende Organisation',
        creationDate: 'Erstellungsdatum',
        documentType: 'Dokumenttyp',
        perimeter: {
          GROUP: 'Gruppe',
          ORGANISATION: 'Firma',
          label: 'Mandatsperimeter'
        },
        title: 'Details',
        updateDate: 'Datum der Änderung'
      },
      editMessage: {
        broadcast: 'Um die Angaben zum Sendemandat zu bearbeiten,',
        collection: 'Um die Angaben zum Inkassomandat zu bearbeiten,'
      },
      information: {
        broadcast: 'Informationen senden',
        collection: 'Informationen zur Sammlung',
        copyToClipboard: 'In Zwischenablage kopieren',
        showValue: 'Wert anzeigen',
        website: 'Webseite'
      },
      title: {
        broadcast: 'Sendemandat für',
        collection: 'Inkassomandat für'
      }
    },
    field: {
      CONVENTION_NUMBER: 'Numéro de convention',
      EMAIL: 'Adresse électronique',
      FIRST_NAME: 'Prénom',
      INSURANCE_COMPANY: 'Compagnie - Agent - Courtier',
      KEY: 'Clé',
      LAST_NAME: 'Nom',
      LOGIN: 'Benutzername',
      PASSWORD: 'Passwort',
      PHONE: 'Numéro de téléphone',
      POLICE_NUMBER: 'Numéro de police',
      REGION: 'Région',
      REGISTRATION_NUMBER: 'SIRET',
      SOCIAL_SECURITY_NUMBER: 'Numéro de sécurité sociale'
    },
    list: {
      comment: 'Kommentar',
      creationDate: 'Erstellungsdatum',
      message: {
        email: 'kontakt.de@onceforall.com',
        firstPart: {
          broadcast: {
            part1: 'Das Sendemandat ist eine bereits in Ihrem Abonnement enthaltene Option, gültige Dokumente(1) Ihrer Organisation auf anderen Plattformen zu verbreiten. Mit dem Sendemandat können Sie sich auf Ihr Geschäft konzentrieren.',
            part2: '(1) Das Dokument ""Liste des salariés étrangers soumis à autorisation de travail" kann nicht aktualisiert werden. Das Dokument "Attestation fiscale" muss im laufenden Jahr ausgegeben werden. Spezifische von Kunden angeforderte Dokumente, die nicht auf unserer Plattform verfügbar sind, müssen von Ihrer Organisation aktualisiert werden.'
          },
          collection: 'Das Inkassomandat ist eine bereits in Ihrem Abonnement enthaltene Option, ausser Expérience Angebot, die es uns ermöglicht, die Aktualisierung Ihrer Dokumente in OFA DE zu verwalten. Mit dem Inkassomandat können Sie sich auf Ihr Geschäft konzentrieren.'
        },
        link: 'hier klicken',
        secondPart: 'Wie wird es aktiviert? Laden Sie das Dokument herunter, indem Sie ',
        thirdPart: ', und senden Sie das ausgefüllte und unterschriebene Dokument an '
      },
      noResult: {
        broadcast: 'Kein Sendemandat für diese Organisation',
        collection: 'Kein Sammelauftrag für diese Firma'
      },
      platform: 'Plattform',
      subtype: 'Dokumenttyp',
      thirdParty: 'Zertifizierende Organisation',
      updateDate: 'Datum der Änderung'
    },
    planUpgradable: 'Ihr derzeitiges Angebot muss aktualisiert werden, um Dokumente auf anderen Plattformen zu verbreiten.',
    platform: {
      AWS: 'AWS',
      EATTESTATIONS: 'e-Attestations',
      MYPROCUREMENT: 'MyProcurement',
      PROVIGIS: 'Provigis'
    },
    platformWebsite: 'Öffnen Sie die Plattform-Website',
    thirdPartyGroup: {
      CIBTP: 'Congés Intempéries BTP - CIBTP',
      CNETP: 'Caisse Nationale des Entrepreneurs de Travaux Publics - CNETP',
      NET_ENTREPRISE: 'Net Entreprise',
      PROBTP: 'PRO BTP',
      TESE: 'Titre emploi service entreprise - TESE',
      URSSAF: 'URSSAF',
      URSSAF_AUTOENT: 'URSSAF Autoentrepreneur',
      URSSAF_INDEP: 'URSSAF Indépendant'
    },
    thirdPartyWebsite: 'Öffnen die Website der zertifizierende Organisation'
  },
  menu: {
    bdr: '[Bâtisseur de Relations]',
    clients: 'Kunden',
    dashboard: 'Dashboard',
    documents: 'Nachweise',
    help: 'Hilfe und Support',
    home: 'Startseite',
    news: '[]',
    panda: '[Access PanDA]',
    profile: 'Mein Profil',
    projects: 'Projekte',
    settings: 'Einstellungen',
    subcontractors: 'Nachunternehmer',
    vitrine: '[Create my references list]'
  },
  message: {
    changesSaved: 'Änderungen wurden gespeichert.',
    exportRequestSuccess: 'Wir haben Ihre Anfrage entgegengenommen. Sie werden die Dateien in Kürze per E-Mail erhalten.',
    lastUpdateDate: 'Letzte Aktualisierung:',
    loading: 'Wird geladen',
    missingPermission: 'Sie haben nicht die nötigen Zugriffsrechte um dieses Dokument zu signieren.',
    missingRequiredFields: 'Alle obligatorischen Felder müssen ausgefüllt sein',
    missingSelectedOrganisation: 'Sie müssen eine Firma auswählen',
    moreResults: '%{results} andere Ergebnisse',
    noData: 'Keine Daten verfügbar',
    pageAccessDenied: 'Die Seite kann nicht aufgerufen werden.',
    pageNotFound: 'Die Seite konnte nicht gefunden werden.',
    projectNotEditable: 'Um Ihre Informationen zu bearbeiten',
    roleNotAllowed: 'Mit Ihrer Nutzerrolle haben Sie keinen Zugriff auf diesen Bereich. Bitte wenden Sie sich an den Kundendienst, um sie zu ändern.',
    selectedOrganisationDenied: 'Sie haben keinen Zugriff auf diese Firma. Ihre Anfrage wurde an den zuständigen Manager übermittelt.',
    textCounter: '%{counter} von %{maxLength} Zeichen'
  },
  notification: {
    document: {
      atDate: '[Your __s%{documentName}__s document is missing for the year __s%{year}__s and is required in  __s%{projectsCount}__s projects. Please upload a valid version for the year __s%{year}__s. Once uploaded, the file will be verified by our Production team within 48h and will then be visible on OnceForAll plateform.]',
      collectionMandateDisabled: {
        FRANCE: 'Das Dokument %{documentName} wird nicht mehr von Attestation Légale abgerufen',
        GERMANY: 'Das Dokument %{documentName} wird nicht mehr von OnceForAll abgerufen'
      },
      created: '%{documentName} wurde Ihrem Nachweisordner hinzugefügt.',
      depositor: 'Sie können nun Dokumente einstellen und Ihren Kunden freigeben.',
      remind: '%{userFullName} fordert Sie auf, den Nachweisordner von %{organisationName} zu vervollständigen.',
      requalified: '%{previousDocumentName} wurde geändert zu %{documentName}',
      validUntil: ' Es wird nun bis %{expirationDate} gültig sein.',
      validated: 'Ihr(e) %{documentName} wurde geprüft.',
      yourDocument: 'Ihr(e) __s%{documentName}__s'
    },
    emptyList: 'Sie haben alle Ihre Benachrichtigungen bearbeitet',
    organisation: {
      automaticAcceptationEnabled: "Sie akzeptieren nun automatisch Einladungen als Nachunternehmer. Diese Einstellung kann auf 'Manuelles Akzeptieren' zurückgesetzt werden.",
      deactivation: {
        inviting: '%{organisationName} kann Ihrem Netzwerk nicht beitreten, da diese Firma deaktiviert wurde.',
        relatedAsClient: '%{organisationName} wurde deaktiviert. Sie können weiterhin auf die hinterlegten Nachweise zugreifen.',
        relatedAsSubcontractor: '%{organisationName} wurde deaktiviert.'
      }
    },
    project: {
      accepted: 'Sie sind dem Projekt %{projectName} beigetreten.',
      closed: 'Das Projekt %{projectName} wurde von %{organisationOwnerName} geschlossen. Sie können weiterhin auf das Projekt und die zugehörigen Nachweise zugreifen.',
      organisationEnded: 'Ihre Firma %{invitedOrganisationName} ist an dem Projekt %{projectName} nicht mehr beteiligt.',
      rejected: '%{invitedOrganisationName} hat Ihre Projekteinladung aus folgendem Grund abgelehnt: %{rejectionReason}',
      updatedRequiredDocumentsInProjectDossierOverview: 'Die für einen gültigen Projekt-Nachweisstatus erforderlichen Dokumente im Projekt %{projectName} wurden bearbeitet.'
    },
    relationship: {
      accepted: {
        AS_CLIENT: 'Sie sind als Auftraggeber dem Netzwerk von %{invitingOrganisationName} beigetreten.',
        AS_SUBCONTRACTOR: 'Sie sind als Nachunternehmer dem Netzwerk von %{invitingOrganisationName} beigetreten.'
      },
      rejected: '%{invitedOrganisationName} hat Ihre Netzwerkeinladung aus folgendem Grund abgelehnt: %{rejectionReason}'
    },
    user: {
      linked: '%{firstName} %{lastName} wurde als Nutzer von %{organisationName} hinzugefügt.',
      permissionsUpdated: {
        MANAGE_PROJECT: {
          ADDITION: '%{firstName} %{lastName} kann jetzt für %{organisationName} Projekte verwalten.',
          DELETION: '%{firstName} %{lastName} kann jetzt nicht mehr Projekte für %{organisationName} verwalten.'
        },
        SIGN: {
          ADDITION: '%{firstName} %{lastName} kann jetzt online Dokumente für %{organisationName} unterzeichnen',
          DELETION: '%{firstName} %{lastName} kann jetzt nicht mehr online Dokumente für %{organisationName} unterzeichnen'
        }
      },
      roleUpdated: {
        CONSULTANT: '%{firstName} %{lastName} ist jetzt ein Sekretariat des %{organisationName}',
        EXPLORER: '%{firstName} %{lastName} ist jetzt ein Beobachter des %{organisationName}',
        INVITING: '%{firstName} %{lastName} ist jetzt ein Relation Manager des %{organisationName}',
        MANAGER: '%{firstName} %{lastName} ist jetzt ein Account Manager des %{organisationName}'
      }
    }
  },
  opera: {
    'platform-ACTRADIS': {
      message: 'Master-Plattform: ACTRADIS'
    },
    'platform-OFA': {
      message: 'Master-Plattform: OFA'
    }
  },
  organisation: {
    accessCode: {
      name: 'Zugangscode',
      tooltip: 'Melden Sie sich direkt bei Ihrem Anbieter mit dem Code an, den er Ihnen eventuell zur Verfügung gestellt hat'
    },
    businessLine: {
      AGRICULTURE: 'Landwirtschaft',
      CLEANING: 'Reinigungsdienste',
      CONSTRUCTION: 'Baugewerbe',
      MANUFACTURING: 'Verarbeitendes gewerbe/Herstellung von waren',
      METAL_PRODUCTS: 'Herstellung von Metallerzeugnissen',
      OTHER: 'Andere',
      PARCEL_DELIVERY: 'Postdienstleistung',
      RENTAL_LEASING: 'Vermietung von beweglichen Sachen',
      SAFETY: 'Sicherheit',
      SERVICE_ACTIVITIES: 'Dienstleistungen',
      TEMPORARY_WORK: 'Zeitarbeit',
      TRANSPORTATION: 'Transport',
      WASTE_MANAGEMENT: 'Sammlung von Abfällen',
      title: 'Geschäftsbereich'
    },
    create: {
      cautionNotice: 'Wenn Sie Nachweise für Ihre Kunden auf OnceForAll vorhalten wollen, achten Sie bitte darauf die Niederlassung zu registrieren, die mit dem Auftraggeber im Vertragsverhältnis steht.',
      errors: {
        sirenNotMatching: '[The SIREN is not matching with the SIRET]'
      },
      privacyPolicyAccepted: 'Ich akzeptiere die Datenschutzerklärung. *',
      requiredNotice: '* Diese Angaben sind Pflicht',
      step1: 'Schritt 1',
      step1Text: 'Geben Sie die %{idNumberName} Ihrer Firma ein',
      step2: 'Schritt 2',
      step2Text: 'Firmeninformationen ausfüllen',
      termsAccepted: 'AGB *',
      title: 'Registrieren Sie meine Firma (Niederlassung)'
    },
    createOrganisation: 'Neue Firma anlegen',
    createOrganisationDeactivated: '%{organisationName} wurde deaktiviert. Sie können dieser Firma nicht  beitreten.',
    createOrganisationFound: 'Diese Firma ist auf OnceForAll. Klicken Sie auf "Weiter", um sich anzumelden.',
    createOrganisationFoundAndLinked: 'Diese Firma ist auf OnceForAll und Sie sind bereits mit ihr verbunden.',
    createOrganisationFoundInILG: 'Diese Firma ist noch nicht auf OnceForAll angemeldet. Klicken Sie auf "Weiter", um sie anzulegen.',
    createOrganisationNotFound: 'Diese Firma ist nicht bekannt. Bitte prüfen Sie die SIRET-Nummer.',
    createOrganisationSuccess: 'Ihr Firma wurde gegründet',
    deactivated: {
      title: 'Deaktivierte Firma',
      tooltip: 'Diese Firma wurde deaktiviert und kann nicht mehr ausgewählt werden.',
      tooltipBackOffice: 'Diese Firma wurde deaktiviert.'
    },
    delete: {
      confirmDeleteOrganisation: {
        content: 'Wollen Sie %{organisationName} wirklich entfernen?',
        warning: {
          client: 'Diese Firma wird keinen Zugriff mehr auf Ihre Nachweise haben.',
          subcontractor: 'Sie werden die Nachweise dieser Firma nicht mehr einsehen können.'
        }
      },
      success: '%{organisationName} wurde entfernt',
      title: 'Firma entfernen',
      tooltip: 'Sie können diese Firma nicht entfernen, da Sie in mindestens einem Projekt beteiligt sind. Nur der Projekteigner kann eine Firma von einem Projekt entfernen.'
    },
    depositorService: {
      noFile: 'Keine Dateien vorhanden',
      notActivated: 'Diese Organisation hinterlegt keine Dokumente mehr.'
    },
    details: 'Details',
    fullName: 'Firma (Niederlassung)',
    inactive: 'Diese Firma ist deaktiviert. Bitte wenden Sie für weitere Informationen an den Kundendienst.',
    invite: 'Firma "%{input}" in mein Netzwerk einladen',
    registrationNumber: 'Registrationsnummer',
    remainingUserAccounts: '%{count} verbleibende Nutzer',
    search: {
      alreadyClient: 'Diese Firma ist bereits einer Ihrer Kunden.',
      alreadyInvited: 'Dieser Nachunternehmer haben Sie bereits eingeladen.',
      alreadyPartOfProject: 'Diese Firma ist bereits Mitglied in diesem Projekt.',
      alreadySelected: 'Diese Firma bzw. Niederlassung ist bereits ausgewählt.',
      alreadySubcontractor: 'Diese Firma ist bereits einer Ihrer Nachunternehmer.',
      inputLabel: 'Firma suchen',
      invite: {
        action: 'Einladen',
        text: 'Sie können ihn einladen, dem OnceForAll-Netzwerk beizutreten',
        title: 'Sie können die gesuchte Firma nicht finden?'
      },
      lastSelected: 'Zuletzt ausgewählte Firmen:',
      notfound: 'Diese Firma ist noch nicht auf OnceForAll angemeldet.',
      placeholder: 'Firmenname, Steuernummer, Ust.-ID',
      self: 'Sie können nicht sich selbst hinzufügen.',
      specifySearch: 'Mehr als 10 Ergebnisse. Bitte grenzen Sie Ihre Suche ein.'
    },
    selectOrganisation: {
      all: 'Ihre gesamten Firmen',
      showAll: 'Zeige alle Firmen',
      title: 'Firma suchen'
    },
    users: {
      noResult: {
        line1: 'Gesuchte Benutzer gehört noch nicht zu dieser Organisation.',
        line2: 'Möchten Sie ihn einladen?'
      },
      searchLabel: 'Suche nach einem Nutzer',
      title: 'Nutzer'
    },
    viewDetails: 'Details',
    website: 'Website'
  },
  organisationSetting: {
    cantEditMessage: 'Um die Details der Organisation zu bearbeiten,',
    cantModifyRole: 'Um Nutzerrollen und -berechtigungen zu bearbeiten,',
    contactCustomerService: 'wenden Sie sich bitte an unseren Kundendienst',
    detailsTitle: 'Details',
    mandates: {
      broadcast: {
        notDepositor: 'Für den Zugriff auf die Sendemandat ist ein aktiver Einlegerservice erforderlich',
        notManager: 'Nur der Account Manager hat Zugriff auf die Sendemandat',
        title: 'Sendemandat'
      },
      collection: {
        notDepositor: 'Für den Zugriff auf die Inkassomandate ist ein aktiver Einlegerservice erforderlich',
        notManager: 'Nur der Account Manager hat Zugriff auf die Inkassomandate',
        title: 'Inkassomandate'
      }
    },
    subscriptionAndInvoicesTabDisabled: 'Nur der Account Manager kann sowohl auf das Abonnement als auch auf die Rechnungen zugreifen',
    subscriptionAndInvoicesTitle: 'Abonnements & Rechnungen',
    upload: 'Auswählen',
    uploadLogo: 'Firmenlogo auswählen',
    usersTitle: 'Nutzer'
  },
  pagination: {
    items: 'Artikel',
    of: 'von',
    to: 'bis'
  },
  panda: {
    access: {
      confirm: '[Access PanDA]',
      text1: '[You want to access PanDA.]',
      text2: '[PanDA platform allows you to simplify and secure the approvment of your subcontractors.]',
      text3: '[In just a few clicks, dematerialize the entire process of approving subcontractors working on your sites.]',
      text4: '[More information about PanDA]',
      text5: '[By clicking on "Access PanDA", your user account and your companies on OnceForAll platform will be automatically synced to PanDA.]'
    },
    discover: {
      cancel: 'Ich möchte meine Anträge auf Genehmigung nicht über PanDA verwalten',
      cta: 'PanDA entdecken',
      text1: '__sVerwalten Sie Anträge auf Genehmigungen online.__s',
      text2: 'Sie haben Ihr Projekt auf der Once for All- Plattform erstellt und verwaltet es darüber. Wie sieht es mit der Online-Verwaltung Ihrer Genehmigungsanträge auf der PanDA-Plattform aus?'
    }
  },
  plan: {
    actions: {
      add: 'Optionen hinzufügen',
      contactUs: 'Kontakt',
      upgrade: 'Aktualisieren zum Einleger'
    },
    currentPlan: 'Ihr aktuelles Angebot',
    free: 'Kostenlos',
    message: {
      upgradeSuccess: 'Ihre Bestellung wurde entgegengenommen. Unser Kundendienst wird Sie in Kürze kontaktieren.'
    },
    modal: {
      additionalProjects: 'Zusätzliche Einzelprojekte',
      additionalProjectsOption: 'einmalige Zahlung, unbegrenzte Laufzeit',
      additionalUsers: 'Zusätzliche Nutzer',
      depositorService: 'Eigene Nachweise für meine Auftraggeber freigeben.',
      title: 'Optionen zu %{type} hinzufügen'
    },
    options: {
      projectInclude: 'Projekte inkl.',
      userInclude: 'Nutzer inkl.'
    },
    perMonth: '/ Monat',
    specialPrice: '*19€ für Einzelunternehmen und GbR'
  },
  project: {
    actionProjectClosed: 'Diese Aktion ist nicht möglich, da dieses Projekt geschlossen ist',
    additionalNotes: 'Beschreibung',
    additionalNotesInfo: 'Diese beschreibung kann von allen Projektteilnehmern eingesehen werden',
    address: 'Projektadresse',
    backToDashboard: 'Zurück zur Projektübersicht',
    backToProjects: 'Zurück zur Projektliste',
    buttonDocuments: {
      download: 'Projektordner speichern',
      expand: {
        tooltip: 'Sie müssen Ihren Nachweisordner aktivieren um diese Dokumente sehen zu können.'
      },
      print: 'Projektordner drucken',
      showDocuments: 'Dokumente anzeigen'
    },
    close: 'Projekt schließen',
    closeSuccess: 'Das Projekt wurde jetzt geschlossen.',
    closedProject: '(Geschlossen)',
    closingDate: 'Geschlossen am',
    confirmProjectClosure: {
      content: 'Dokumente und Status sind weiterhin verfügbar.\nSie können jedoch keine weiteren Firmen einladen.\nAusstehende Einladungen werden gelöscht.',
      title: 'Wollen Sie das Projekt wirklich beenden?',
      warning: 'Diese Aktion kann nicht rückgängig gemacht werden! Ein beendetes Projekt kann nicht wieder aktiviert werden.'
    },
    create: {
      button: 'Neues Projekt erstellen',
      creationSuccess: 'Das Projekt %{name} wurde erstellt!',
      projectCreditsTooltip: 'Sie haben keine Projektkredite mehr. Bitte wenden Sie sich an unseren Kundendienst um weitere Kredite zu erwerben.',
      title: 'Projekt erstellen'
    },
    creditsNominative: '__s%{count}__s verbleibende Nominativ-Projekt-Kredite',
    creditsNominative_0: '__s%{count}__s verbleibend Nominativ-Projekt-Kredit',
    creditsNominative_1: '__s%{count}__s verbleibend Nominativ-Projekt-Kredit',
    creditsStandard: '__s%{count}__s verbleibende Standard-Projekt-Kredite',
    creditsStandard_0: '__s%{count}__s verbleibend Standard-Projekt-Kredit',
    creditsStandard_1: '__s%{count}__s verbleibend Standard-Projekt-Kredit',
    description: {
      notice: 'Sie können den Kundendienst kontaktieren, um diese Informationen zu bearbeiten, sobald das Projekt erstellt ist.',
      requiredNotice: '* Diese Angaben sind Pflicht',
      title: 'Projektbeschreibung'
    },
    details: 'Details',
    documentAtDateMessage: 'Das hinterlegte Dokument muss am Startdatum des Projektes __s%{date}__s gültig sein.',
    documentAtInterventionDateMessage: 'Das hochgeladene Dokument muss zum Zeitpunkt des Beginns der Projektintervention gültig sein: __s%{interventionDate}__s',
    documents: 'Nachweise',
    documentsStates: {
      ALMOST_EXPIRED: 'Bald ungültig',
      MISSING: 'Fehlt / Abgelehnt / Ungültig',
      VALID: 'Geprüft'
    },
    documentsStillValid: 'Noch gültig',
    edit: {
      addOrganisation: 'Firma hinzufügen',
      addOrganisationExternalSuccess: 'Die Firma %{name} wurde eingeladen.',
      addOrganisationInternalSuccess: 'Die Firma %{name} wurde in das Projekt eingeladen',
      changeOrganisation: 'Firma ändern',
      changeRole: 'Rolle ändern',
      descriptionsPerRole: {
        CLIENT: '<span>Ein Bauherr kann Firmen in das Projekt einladen (Generalunternehmer, Projektentwickler, Nachunternehmer oder Dienstleister) und auf deren Nachweise zugreifen.</span>',
        GENERAL_CONTRACTOR: '<span>Ein Generalunternehmer stellt ggf. eigene Nachweise ein, kann Firmen in das Projekt einladen (Bauherr, weitere Generalunternehmer, Projektentwickler, Nachunternehmer oder Dienstleister) und auf Nachweise seiner Nachunternehmer zugreifen.</span>',
        PROJECT_MANAGER: '<span>Ein Projektentwickler stellt ggf. eigene Nachweise ein, kann Firmen in das Projekt einladen (Bauherr, weitere Generalunternehmer, Projektentwickler, Nachunternehmer oder Dienstleister) und auf Nachweise seiner Nachunternehmer zugreifen.</span>',
        PROJECT_MANAGER_CLIENT: '<span>Ein Projektentwickler stellt ggf. eigene Nachweise ein, kann Firmen in das Projekt einladen (Bauherr, weitere Generalunternehmer, Projektentwickler, Nachunternehmer oder Dienstleister) und auf Nachweise seiner Nachunternehmer zugreifen.</span>',
        SERVICE_PROVIDER: '<span>Ein Dienstleister stellt seine Nachweise ein, kann eigene Sub-Dienstleister einladen und auf deren Dokumente zugreifen.</span>',
        SUB_CONTRACTOR: '<span>Ein Nachunternehmer stellt seine Nachweise ein, kann eigene Nachunternehmer einladen und auf deren Dokumente zugreifen.</span>'
      },
      editDocuments: 'Änderungen bestätigen',
      editProjectDescription: 'Projektinformationen bearbeiten',
      editProjectDescriptionSuccess: 'Das Projekt "%{name}" wurde geändert.',
      editRequiredDocuments: 'Angeforderte Dokumente bearbeiten',
      externalInvitationSuccess: 'Sobald sich der eingeladene Nutzer bei OnceForAll registriert und seine Organisation hinzufügt, wird diese Organisation automatisch zum Projekt hinzugefügt.',
      message: {
        EXTERNAL: 'Per E-Mail auf Plattform einladen',
        INTERNAL: 'Hinzufügen'
      },
      notEditable: '[You first need to upload the specifications document and/or the CCRD in order to require this document. Since then, the customer service will create this document as soon as possible.]',
      organisation: 'Firma auswählen',
      requiredForDossierOverviewStatus: 'Für gültigen Projekt-Nachweisstatus erforderlich',
      requiredForProject: 'Für Projekt angefordert',
      roleAs: 'Als',
      roleType: 'Rolle auswählen',
      seeRequiredDocuments: 'Angeforderte Dokumente anzeigen',
      title: 'Firma hinzufügen',
      warning: '<strong>Achtung:</strong> Wenn Sie das Eröffnungsdatum des Projekts ändern, werden alle decennialen Bescheinigungen zum Eröffnungsdatum des Projekts neu berechnet. Bitte stellen Sie sicher, dass Sie sich der Änderung sicher sind, bevor Sie diese bestätigen, um Fehler zu vermeiden.'
    },
    exportDossier: 'Projekt-Nachweisordner exportieren',
    exportQuitus: 'Projekt-Nachweisstatus Übersicht herunterladen',
    goToChart: 'Organigramm anzeigen',
    grantAccess: {
      button: 'Projektzugang gewähren',
      missing: 'Wenn Sie einen Benutzer in der Liste nicht finden, können Sie ihn im Anschluss hinzufügen, indem Sie sich bitte an Ihren Account Manager oder an den ',
      missingLink: 'Kundendienst wenden.',
      title: 'Projektzugang gewähren',
      user: {
        fullName: 'Name',
        role: 'Funktion',
        viewProject: 'Projekt anzeigen'
      }
    },
    internalNotes: {
      author: 'Notiz von %{fullName}',
      creationDate: 'Anegelegt von ',
      newInternalNote: 'Neue interne Notiz',
      title: 'Interne Notizen'
    },
    internalReference: 'Interne Referenz',
    invite: {
      client: {
        defaultMessage: 'Im Rahmen des Bauvorhabens %{projectName} und mit dem Ziel die Nachweisverwaltung zu erleichtern, bittet Sie %{userName} von %{organisationName}, sich über folgenden Link auf OnceForAll anzumelden.\nAls Auftraggeber erhalten Sie anschließend kostenlose einen Überblick über den Compliance-Status aller am Projekt %{projectName} teilnehmenden Firmen.\nOnceForAll ist ein unabhängiges Dienstleistungsangebot. Es trägt zur Sicherung Ihrer Geschäftsbeziehungen bei, indem es Nachunternehmern hilft einen jederzeit vollständigen und aktuellen Nachweisordner vorzuhalten.'
      },
      depositor: {
        defaultMessage: 'Im Rahmen des Bauvorhabens %{projectName} und mit dem Ziel die Nachweisverwaltung zu erleichtern, bittet Sie %{userName} von %{organisationName}, sich auf OnceForAll anzumelden.\nOnceForAll ist ein unabhängiges Dienstleistungsangebot. Es trägt zur Sicherung Ihrer Geschäftsbeziehungen bei, indem es Ihnen hilft einen jederzeit vollständigen und aktuellen Nachweisordner vorzuhalten.\nAuch andere Kunden können Ihre Dokumente einsehen - wenn Sie das wollen. Einzig Sie entscheiden, wer Zugriff auf Ihre Nachweise hat.\n\n%{userName} von %{organisationName}'
      },
      title: 'Firma einladen'
    },
    myProjects: 'Projekte',
    name: 'Bezeichnung',
    noProjects: 'Kein Projekt gefunden',
    notifications: {
      cancel: 'Bereits getan',
      grantAccess: 'Haben Sie für Ihre Kollegen Zugang zu diesem Projekt eingerichtet?',
      requiredDocuments: 'Sind die erforderlichen Dokumente für dieses Projekt festgelegt?'
    },
    openingDate: 'Projektbeginn',
    organisationDocuments: 'Dokumente für Firma %{organisationName}',
    organisationHasNoDocuments: 'Diese Firma hat keine Dokumente.',
    organisations: {
      title: 'Firmen hinzufügen'
    },
    ownerOrganisation: 'Angelegt von',
    participants: {
      description: 'Projektteilnehmer',
      title: 'Teilnehmer'
    },
    projectAccepted: 'Die Einladung zu dem Projekt wurde angenommen.',
    projectAlreadyClosed: 'Das Projekt wurde geschlossen. Sie können nicht mehr beitreten.',
    projectAlreadyReplied: 'Diese Einladung haben Sie bereits beantwortet',
    projectClosedChip: 'Geschlossenes Projekt',
    projectInviterRemoved: 'Sie können diesem Projekt nicht beitreten, weil die Firma, die Sie eingeladen hat, nicht mehr an diesem Projekt beteiligt ist.',
    projectRejected: 'Die Einladung zu dem Projekt wurde abgelehnt.',
    provisionalAcceptanceDate: 'Voraussichtliche Fertigstellung',
    quitus: 'Nachweisübersicht',
    quitusDescription: 'der Projektteilnehmer haben einen vollständigen Nachweisordner.',
    requiredDocuments: {
      message1: '__sFür Projekt angefordert__s: Die in dieser Spalte ausgewählten Dokumente werden für alle am Projekt beteiligten Unternehmen entsprechend ihrer Branche und dem jeweiligen Herkunftsland erfasst.',
      message2: '__sFür gültigen Projekt-Nachweisstatus erforderlich__s: Diese Spalte erlaubt das Anpassen des Statusüberblicks der Projektakte. Die Gültigkeit wird anhand der ausgewählten Dokumente bemessen. Zum Bespiel: Die Bankverbindung ist für das Projekt als erfasst markiert, jedoch nicht als benötigt für den Statusüberblick der Projektakte: Es wird vom Unternehmen angefordert, aber beim Fehlen wird es zu keiner Ungültigkeit des Statusüberblicks der Projektakte führen.',
      title: 'Angeforderte Dokumente',
      tooltip: {
        FOREIGN: 'Dieses Dokument ist nur für ausländische Unternehmen und Niederlassungen notwendig',
        businessLines: 'Dieses Dokument ist nur für Unternehmen der folgenden Sektoren erforderlich: ',
        businessLines_1: 'Dieses Dokument ist nur für Unternehmen der folgenden Sektoren erforderlich: '
      }
    },
    roleForm: {
      change: 'Rolle wechseln',
      choose: 'Diese Rolle auswählen',
      client: {
        firstPoint: 'Alle am Projekt teilnehmenden Firmen sehen',
        intro: 'Ein Projekt als __sKunde__s erstellen bedeutet:',
        secondPoint: 'Nur Generalunternehmer können eingeladen werden',
        thirdPoint: 'Nachweise aller teilnehmenden Firmen können abgerufen werden'
      },
      generalContractor: {
        firstPoint: 'Am Projekt teilnehmenden Firmen sehen',
        intro: 'Ein Projekt als __sGeneralunternehmer__s erstellen bedeutet:',
        secondPoint: 'Es können der Kunde, andere Generalunternehmer und Nachunternehmer können in das Projekt eingeladen werden',
        thirdPoint: 'Nachweise aller Ihrer Nachunternehmer können abgerufen werden'
      },
      notice: 'Bitte wählen Sie die Rolle von __s%{organisationName}__s in diesem Projekt',
      projectManagerClient: {
        firstPoint: 'Alle am Projekt teilnehmenden Firmen sehen',
        intro: 'Ein Projekt als __sBauleiter__s erstellen bedeutet:',
        secondPoint: 'Der Kunde, andere Generalunternehmer und Nachunternehmer können in das Projekt eingeladen werden',
        thirdPoint: 'Nachweise aller teilnehmenden Firmen können abgerufen werden'
      },
      title: 'Rolle des Projekterstellers'
    },
    search: {
      notfound: 'Keine Ergebnisse',
      placeholder: 'Bezeichnung'
    },
    selectIntervention: {
      invitedBy: 'Eingeladen von %{invitingOrganisationName}',
      message: 'Ihre Firma hat mehrere Rollen in diesem Projekt, bitte wählen Sie die Rolle aus, mit der Sie dieses Projekt sehen möchten.',
      title: 'Rolle auswählen'
    },
    showInvalidDocumentsPage: 'Ungültige Dokumente anzeigen',
    subcontractors: {
      description: 'Nachunternehmer im Projekt',
      title: 'Nachunternehmer'
    },
    tree: {
      title: 'Organigramm',
      clients: 'Bauherrschaft',
      projectManagers: 'Bauleitung',
      supplyChain: 'Kette von Unteraufträgen'
    },
    type: {
      NOMINATIVE: 'Nominativ',
      STANDARD: 'Standard'
    },
    typeForm: {
      NOMINATIVE: {
        fifthPoint: 'Dokumente projektspezifisch prüfen lassen',
        firstPoint: 'einen designierten Projektbereich erstellen',
        fourthPoint: 'projektspezifische Dokumente anfordern',
        intro: 'In einem Nominativ-Projekt können Sie',
        secondPoint: 'die Nachunternehmer-Kette verwalten',
        thirdPoint: 'mit Hilfe des Projekt-Dashboards die Baustelle steuern'
      },
      STANDARD: {
        firstPoint: 'einen designierten Projektbereich erstellen',
        intro: 'In einem Standard-Projekt können Sie',
        secondPoint: 'die Nachunternehmer-Kette verwalten',
        thirdPoint: 'mit Hilfe des Projekt-Dashboards die Baustelle steuern'
      },
      change: 'Typ ändern',
      choose: 'Auswählen',
      notice: 'Bitte wählen Sie, welche Art Projekt Sie erstellen wollen.',
      title: 'Projekt-Typ'
    },
    upgradeToNominative: {
      title: '[Upgrade to nominative project]',
      tooltip: '[There is no sufficient nominative project credits left]'
    },
    viewDetails: 'Details'
  },
  registerFirstTime: {
    import: 'Ihre Dokumente hochladen und freigeben',
    joinOrganisation: 'Treten Sie einer Organisation bei, die bereits auf OFA existiert.',
    joinOrganisationSubtitle: 'Verwenden Sie die Betriebsnummer dieser Organisation!',
    network: 'Ihr Netzwerk erweitern',
    newOrganisation: 'Sie können eine neue Organisation anmelden.',
    newOrganisationSubtitle: 'Geben Sie Ihre Anmeldeinformationen an, um zu beginnen !',
    optionsTitle: 'Ihre Organisation ist noch nicht bei OnceForAll?',
    participate: 'Teilnahme an Projekten',
    start: 'Klicken Sie unten zum Start!',
    startButton: 'Registrieren Sie Ihre Organisation',
    subtitle: 'Mit uns können Sie:',
    title: 'Erstmals bei OFA?',
    view: 'Die Dokumente Ihrer Unterlieferanten einsehen'
  },
  rejectionReason: {
    displayLabel: 'Einladung abgelehnt: ',
    label: 'Grund für Ablehnung auswählen',
    reason: {
      ACTRADIS_MEMBER: 'Bereits auf einer Interop-Plattform angemeldet.',
      ALREADYACTIVECUSTOMER: 'Anmeldung im Gange',
      ALREADYMEMBEROFAFREEPLATFORM: 'Kann sein Dossier bereits außerhalb von OnceForAll verfügbar machen.',
      CESSATIONOFACTIVITY: 'Geschäftsaufgabe',
      CESSATION_OF_ACTIVITY: 'Geschäftsaufgabe',
      DOINVITATIONERROR: 'Fehlerhafte Einaldung',
      DO_INVITATION_MISTAKE: 'Fehlerhafte Einaldung',
      FILE_ALREADY_TRANSMITTED: 'Dossier bereits übermittelt',
      FREE_PLATFORM_MEMBER: 'Kann sein Dossier bereits außerhalb von OnceForAll verfügbar machen.',
      INCORRECTCONTACTDETAILS: 'Falsche Kontaktdaten',
      INSCRIPTION_ONGOING: 'Anmeldung im Gange',
      INSUFFICIENT_CUSTOMERS_NUMBER: 'Nicht genügend Kunden auf OnceForAll.',
      KEEP_SENDING_FILE_BY_EMAIL: 'Will Dokumente nur per E-Mail oder Post senden.',
      NOBUDGET: 'Will für Verfügbarmachen seiner Nachweise nicht bezahlen.',
      NOLONGERRESPONDING: 'Nicht erreichbar',
      NOT_INFORMED: 'Wurde von seinem Auftraggeber nicht informiert.',
      NOT_MANDATORY: 'Keine Verpflichtung',
      NOT_WORKING_WITH_ORGANISATION: 'Ich arbeite nicht mit dieser Firma.',
      NO_ACTIVE_CONTRACT: 'Ich habe keinen aktiven Vertrag mit diesem Kunden',
      NO_FILE_SHARING_WANTED: 'Will kein Online-Dossier verfügbar machen.',
      NO_LONGER_WORKING_WITH_ORGANISATION: 'Ich arbeite nicht mehr mit dieser Firma.',
      NO_REASON_GIVEN: 'keine Angabe',
      PLATFORM_SECURITY_SCEPTIC: 'Hat Zweifel an der Sicherheit der OFA-Plattform.',
      PRICE: 'Will für Verfügbarmachen seiner Nachweise nicht bezahlen.',
      PRICETOOHIGH: 'Will für Verfügbarmachen seiner Nachweise nicht bezahlen.',
      SUBJECT_STUDIED_BY_MANAGEMENT: 'Thema wird auf Leitungsebene geprüft',
      UNDERREVIEW: 'Thema wird auf Leitungsebene geprüft',
      UNKNOWN_CLIENT: 'Ich kenne diesen Kunden nicht',
      UNKNOWN_ORGANISATION: 'Ich kenne diese Firma nicht.',
      UNREACHABLE: 'Nicht erreichbar',
      WORKS_WITH_ANOTHER_ORGANISATION: 'Dieser Kunde arbeitet mit einer anderen meiner Firmen zusammen',
      WRONG_CONTACT_INFORMATIONS: 'Falsche Kontaktdaten'
    },
    title: 'Einladung von %{invitingOrganisationName}'
  },
  relationship: {
    errorDepositorService: 'Um Einladungen zu verwalten müssen Sie Ihre Angebot upgraden.'
  },
  resendInvitationReason: {
    explanatory: 'Bitte geben Sie einen Grund für den Neuversand ein',
    placeholder: 'Ich versende die Einladung erneut, weil ...',
    reason: 'Grund',
    title: 'Einladung neu versenden'
  },
  settings: {
    collectorNotifications: 'Auftraggeber-Benachrichtigungen',
    collectorNotificationsMention: 'Wöchentliche E-Mail-Übersicht bestellen.\nEin wöchentlicher Übersicht zeigt den Status aller Ihrer Nachunternehmer an.',
    invitation: {
      priorAcceptation: {
        label: 'Einladungen von Auftraggebern automatisch akzeptieren',
        notDepositor: 'Sie können diese Einstellung nicht ändern, wenn Sie keine Nachweise auf OnceForAll vorhalten.',
        notManager: 'Sie haben nicht genügend Rechte, um diese Einstellung zu ändern'
      },
      title: 'Netzwerk-Einladungen verwalten'
    },
    mySettings: 'Einstellungen',
    subscribeTo: {
      COLLECTOR_EVENT: 'Ereignis-Benachrichtigung bestellen',
      COLLECTOR_EVENT_PROJECT: 'Ereignis-Benachrichtigung für Projekte bestellen',
      COLLECTOR_PERIODIC: 'Wöchentliche Übersicht bestellen',
      COLLECTOR_PERIODIC_PROJECT: 'Wöchentliche Übersicht fürProjekte bestellen'
    },
    tooltip: {
      COLLECTOR_PERIODIC: 'Sie haben keine Nachunternehmer',
      COLLECTOR_PERIODIC_PROJECT: 'Sie nehmen derzeit an keinen Projekten teil'
    }
  },
  signature: {
    canceledMessage: 'Die Signatur für dieses Dokuöent wurde verweigert.',
    successMessage: 'Das Dokument wurde erfolgreich unterschrieben.'
  },
  subcontractor: {
    accessCode: {
      download: 'Zugangscode herunterladen',
      label: 'Zugangscode benutzen',
      modal: {
        errorNotFound: 'Dieser Zugangscode ist fehlerhaft oder er wurde bereits benutzt.',
        message: 'Bitte geben Sie Ihren Zugangscode ein um auf den Nachweisordner Ihres Nachunternehmers zuzugreifen.',
        title: 'Zugangscode benutzen'
      },
      success: 'Die Firma wurde zu Ihrer Nachunternehmerliste hinzugefügt.'
    },
    add: {
      addSuccess: 'Die Firma %{name} wurde zu Ihrer Nachunternehmerliste hinzugefügt.',
      button: 'Nachunternehmer hinzufügen',
      inviteSuccess: 'Einladung verschickt. Annahme durch NU %{name} ausstehend',
      title: 'Nachunternehmer hinzufügen'
    },
    archives: 'Archive',
    documents: 'Nachweise',
    export: 'Nachweisordner meiner Nachunternehmer exportieren',
    invitations: {
      sent: 'Versandte Einladungen'
    },
    invite: {
      defaultMessage: 'Sehr geehrte Damen und Herren,\n\nMit dem Ziel die Nachweisverwaltung zu erleichtern, bittet Sie %{userName} von %{organisationName}, sich über folgenden Link auf OnceForAll anzumelden.\nAls Nachunternehmer geben Sie %{organisationName} Zugriff auf Ihren Nachweisordner. Ihr Kunde wird Ihre Dokumente jederzeit einsehen, herunterladen und drucken können.\nOnceForAll ist ein unabhängiges Dienstleistungsangebot. Es trägt zur Sicherung Ihrer Geschäftsbeziehungen bei, indem es Ihnen hilft einen jederzeit vollständigen und aktuellen Nachweisordner vorzuhalten.\nAuch andere Kunden können Ihre Dokumente einsehen - wenn Sie das wollen. Einzig Sie entscheiden, wer Zugriff auf Ihre Nachweise hat.\n\n%{userName} von %{organisationName}',
      inviteSuccess: 'Sobald sich der eingeladene Nutzer bei OnceForAll registriert und seine Organisation hinzufügt, wird diese Organisation automatisch mit der Ihren als Nachunternehmer verknüpft.',
      reinviteDefaultMessage: '%{userName} von %{organisationName}, lädt Sie ein, OFA erneut beizutreten, um die Verwaltung Ihrer Dokumente zu erleichtern.\nAls deren Nachunternehmer geben Sie %{userName} Zugang zu Ihren Dokumenten, die sich auf der OFA-Plattform befinden.\nDa Sie unsere Plattform bereits zuvor genutzt haben, brauchen Sie nur auf die Schaltfläche unten zu klicken und Ihr neues Abonnement auszuwählen.',
      resendSuccess: '[%{name} has been invited again!]',
      title: 'Einen Nachunternehmer einladen'
    },
    mySubcontractors: 'Nachunternehmer',
    projects: 'Projekte',
    reinvite: {
      action: 'Wieder einladen',
      text: 'Damit er seine Nachweise aktualisieren kann, laden Sie ihn ein, dem OnceForAll-Netzwerk erneut beizutreten, indem Sie auf die Schaltfläche oben klicken.',
      title: 'Dieser Nachunternehmer ist nicht mehr auf der Plattform aktiv',
      tooltip: 'Laden Sie diesen Nachunternehmer ein, OnceForAll erneut beizutreten'
    },
    reminders: 'Erinnerungen',
    search: {
      notFound: 'Kein Nachunternehmer gefunden'
    }
  },
  subscription: {
    collector: 'Sammler',
    collector_and_depositor: 'Sammler & Einleger',
    help: {
      firstPart: 'Auf ',
      link: 'dieser Seite',
      secondPart: ' finden Sie weitere Details zur Berechnung der Anzahl an Kunden.'
    },
    nbClients: 'Sie teilen Ihre Dokumente mit __s%{count}__s Kunden.',
    noResult: 'Sie müssen Ihren Vorgesetzten kontaktieren, um die Einzelheiten Ihres Abonnements zu erfahren.',
    remainingNominativeProjects: '__s%{count}__s verbleibende Nominativ-Projekt-Kredite',
    remainingStandardProjects: '__s%{count}__s verbleibende Standard-Projekt-Kredite',
    remainingUserAccounts: '__s%{count}__s verbleibende Nutzer',
    title: 'Angebot',
    validUntil: 'Angebot gültig bis __s%{date}__s'
  },
  subscriptions: {
    plans: {
      actualPlan: 'ANGEBOT',
      clientOrganisations: 'Für Auftraggeber',
      collectDocuments: 'Nachweise von Nachunternehmern anfordern',
      currency: {
        EUR: '€'
      },
      customerServiceMessage: 'Für weitere Informationen wenden Sie sich bitte an unseren Kundendienst.',
      fee: '* Anmeldegebühr: %{price}',
      fee_0: 'Keine Anmeldegebühr',
      free: 'Kostenlos',
      offer: 'Angebot',
      option: 'Optionen',
      or: ' ',
      pricePeriod: {
        month: '__c%{count}__c/Monat zzgl. USt.',
        none: '__c%{count}__c zzgl. USt.',
        year: '__c%{count}__c/Jahr zzgl. USt.'
      },
      seeMore: 'Mehr',
      services: {
        de_cie_registration_purchase_v1: 'Aktueller HR-Auszug 1x pro Jahr',
        de_document_auth_v1: 'Überprüfen und validieren Ihrer eigenen Nachweise',
        de_illimited_hotline_v1: 'Unbegrenzter und kostenloser Hotline-Support',
        de_included_clients_v1: 'Eigene Nachweise für __s%{count}__s Kunden freigeben',
        de_online_dossier_v1: '__sEinhaltung__s : Übersicht, Einzelansicht, Archiv Ihrer eigenen Nachweise. Erinnerung bei Gültigkeitsablauf.',
        de_unlimited_clients_v1: 'Eigene Nachweise für alle Kunden freigeben',
        fr_document_auth_v1: 'Überprüfen und validieren Ihrer eigenen Nachweise',
        fr_illimited_hotline_v2: 'Unbegrenzter und kostenloser Hotline-Support',
        fr_included_broadcasting_mandate_v1: '__sSynchronisierung eigener Nachweise mit Partner-Plattformen:__s e-Attestations, MyProcurement, Provigis, AWS',
        fr_included_collection_mandate_v1: '__sAbrufvollmacht:__s Abruf Ihrer Nachweise von bestimmten Organismen durch unsere Mitarbeiter.',
        fr_included_onceforall_platforms_v1: 'Synchronisierung von Dokumenten mit Once for All-Plattformen : Actradis, Déclarations Légales, Hiveo',
        fr_kbis_purchase_v1: 'Aktueller Kbis 4x pro Jahr',
        fr_limited_clients_v1: 'Eigene Nachweise für __s%{count} Kunden freigeben__s',
        fr_online_dossier_v1: '__sEinhaltung__s : Übersicht, Einzelansicht, Archiv Ihrer eigenen Nachweise. Erinnerung bei Gültigkeitsablauf.',
        fr_unlimited_clients_v1: 'Eigene Nachweise für alle Kunden freigeben',
        fr_free_bdr: '__sBâtisseur de Relations__s : Zugang zu neuen öffentlichen und privaten Geschäftsmöglichkeiten, Referenzierung und Sichtbarkeit in unserem Netzwerk',
        it_document_auth_v1: 'Überprüfen und validieren Ihrer eigenen Nachweise',
        it_illimited_hotline_v1: 'Unbegrenzter und kostenloser Hotline-Support',
        it_online_dossier_v1: '__sEinhaltung__s : Übersicht, Einzelansicht, Archiv Ihrer eigenen Nachweise. Erinnerung bei Gültigkeitsablauf.',
        it_unlimited_clients_v1: 'Eigene Nachweise für alle Kunden freigeben'
      },
      shareDocuments: 'Eigene Nachweise für Kunden freigeben',
      smallOrganisations: 'Für kleine Unternehmen mit bis zu %{count} Mitarbeitern',
      subscribe: 'Abonnieren',
      title: {
        de_basic_1y_v1: 'Basic',
        de_oncefor2_1y_v1: 'OnceFor2',
        de_onceforall_1y_v1: 'OnceForAll',
        fr_collector_sme_1y_v1: 'Collectant PME',
        fr_essential_v1: 'ESSENTIEL',
        fr_experience_v1: 'EXPÉRIENCE',
        fr_horizon_v1: 'HORIZON',
        fr_liberty_v1: 'LIBERTÉ',
        fr_essentialbdr: 'BUSINESS ESSENTIEL',
        fr_experiencebdr: 'BUSINESS EXPÉRIENCE',
        fr_horizonbdr: 'BUSINESS HORIZON',
        fr_libertybdr: 'BUSINESS LIBERTÉ',
        fr_onceforeignbdr: 'BUSINESS ONCE FOREIGN',
        fr_oncefor2_1y: 'ONCEFOR2',
        fr_onceforall_1y: 'ONCEFORALL',
        fr_onceforeign_1y: 'Once Foreign',
        fr_onceforever_1y: 'ONCEFOREVER',
        fr_onceformore_1y: 'ONCEFORMORE',
        it_basiccollector_V1: 'Basic',
        it_onceforall_1y: 'OnceForAll',
        it_onceforeign_1y: 'OnceForeign'
      },
      unit: {
        project: ' / projekt',
        user: ' / nutzer'
      }
    },
    questions: {
      shareCompliance: {
        title: 'Möchten Sie Ihre Angaben zur Einhaltung von Vorschriften weitergeben?',
        response: {
          yes: 'Yes',
          no: 'No'
        }
      },
      nbOfClients: {
        title: 'An wie viele Kunden?',
        response: {
          info: 'Wählen Sie die Anzahl der Kunden',
          twoClients: 'Bis zu 2 Kunden',
          twentyClients: 'Bis zu 20 Kunden',
          fiftyClients: 'Bis zu 50 Kunden',
          moreThanFiftyClients: '51 Kunden und mehr'
        }
      }
    },
    title: 'Verfügbare Angebote für Ihre Firma'
  },
  textsToValidate: {
    accept: {
      privacyPolicy_1: 'Ich bestätige, dass ich die ',
      privacyPolicy_2: 'Datenschutzerklärung ',
      required: 'gelesen habe und ihnen zustimme.*',
      termsAndConditions_1: 'Ich bestätige, dass ich die ',
      termsAndConditions_2: 'Allgemeine Geschäftsbedingungen ',
      termsAndConditions_3: 'und die ',
      termsAndConditions_4: 'Allgemeinen Nutzungsbedingungen '
    },
    button: 'Akzeptieren',
    privacyPolicy: 'Datenschutzerklärung',
    subtext: ' ',
    termsAndConditions: 'Allgemeine Geschäftsbedingungen',
    termsOfUse: 'Allgemeinen Nutzungsbedingungen',
    text: 'Unsere Datenschutzerklärung und Geschäftsbedingungen wurden aktualisiert. Bitte lesen und akzeptieren Sie diese um unsere Plattform weiter nutzen zu können.',
    title: 'Datenschutzerklärung und Geschäftsbedingungen',
    tooltip: 'Klicken Sie hier, um den Text in einem neuen Tab zu öffnen'
  },
  uploadImage: {
    errorTypeMessage: 'Das Format Ihres Bild ist nicht korrekt'
  },
  uploadLogo: {
    dragDropHere: 'Hierher ziehen und ablegen (png, jpg, jpeg)',
    title: 'Firmenlogo',
    uploadSuccess: 'Ihr Logo wurde aktualisiert'
  },
  user: {
    account: 'Mein Konto',
    actions: {
      untieUser: 'Verbindung von %{firstname} %{lastname}'
    },
    add: 'Nutzer einladen',
    canNotUpdateProfile: 'Um den Profil zu ändern, ',
    canNotUpdateProfileLinkText: 'wenden Sie sich bitte an den Kundendienst.',
    changeEmailAddress: 'Ihre E-Mail-Adresse ändern',
    changeEmailButton: 'E-Mail-Adresse ändern',
    deactivatedUser: 'Der Nutzer %{firstname} %{lastname} wurde deaktiviert.',
    domainNameAutomaticTieUser: 'Nutzer mit E-Mail-Adressen, die auf __s%{domainName}__s enden, können dieser Firma automatisch beitreten mit __s"Beobachter"-Rolle__s.',
    email: 'E-Mail',
    emailChanged: 'Eine E-Mail zur Bestätigung wurde an %{newEmail} gesandt.',
    emailConfirmation: 'E-Mail-Adresse bestätigen',
    firstName: 'Vorname',
    formTitle: 'OnceForAll registrieren',
    invite: {
      alreadyInvited: 'Dieser Nutzer wurde bereits eingeladen.',
      alreadyPartOfOrganisation: 'Dieser Nutzer gehört bereits zu Ihrer Firma.',
      alreadySelected: 'Dieser Nutzer wurde bereits ausgewählt.',
      button: 'Benutzer einladen',
      deactivatedUser: 'Dieser Benutzer ist deaktiviert',
      defaultMessage: 'Sie wurden von %{userName} als Nutzer für die Firma %{organisationName} eingeladen. Bitte melden Sie sich zunächst mit Ihrer E-Mail-Adresse und dem vorläufigen Passwort an.',
      defaultUserMessage: 'Sie wurden von %{userName} von %{invitingOrganisationName} (%{invitingOrganisationRegistrationNumber}) als Nutzer für die Firma %{invitedOrganisationName} (%{invitedOrganisationRegistrationNumber}) eingeladen. Bitte melden Sie sich zunächst mit Ihrer E-Mail-Adresse und dem vorläufigen Passwort an.',
      orgaDeactivated: 'Sie können einen Benutzer nicht in eine deaktivierte Organisation einladen.',
      orgaNonDepositor: 'Sie können einen Benutzer nicht in eine Organisation einladen, die kein Einleger mehr ist.',
      panelTitle: 'Einen Benutzer in dieser Organisation einladen',
      self: 'Sie können nicht sich selbst hinzufügen.',
      successMessage: 'Sie haben %{count} Nutzer in Ihre Firmennutzerliste eingeladen.',
      successMessage_1: 'Sie haben %{name} in Ihre Firmennutzerliste eingeladen.',
      successfullyInvitedUserToRelationship: 'Sie haben %{name} in diese Firmennutzerliste eingeladen.',
      title: 'Einen neuen Nutzer für Ihre Firma einladen',
      userAlreadyTiedToOrganisation: 'Dieser Benutzer ist bereits Teil dieser Organisation'
    },
    language: 'Sprache',
    lastName: 'Name',
    manageProject: 'Projektverwaltung',
    maxUsersReached: 'Max. Nutzeranzahl erreicht.',
    missingSubscription: 'Sie können diese Aktion nicht ausführen, da für sie kein Abonnement vorliegt.',
    mobilePhoneNumber: 'Mobiltelefon',
    myProfile: 'Konto',
    notSelectedWarning: 'Sie müssen einen Nutzer einladen.',
    options: {
      COLLECTOR_PERIODIC_PROJECT_REPORT: 'Ich akzeptiere per E-Mail die Projekt-Nachweisstatus Übersicht zu erhalten',
      SUGGESTION_DISPLAY: 'Ich bin damit einverstanden, eine Liste von Kunden zu sehen, mit denen ich mein Ordner teilen möchte',
      title: 'Optionen'
    },
    password: 'Paßwort',
    passwordConfirmation: 'Paßwort bestätigen',
    phoneNumber: 'Telefon',
    position: 'Stellenbezeichnung',
    registrationDate: 'Registrierungsdatum',
    role: 'Funktion',
    roles: {
      CONSULTANT: 'Sekretariat',
      EXPLORER: 'Beobachter',
      INVITING: 'Relation Manager',
      MANAGER: 'Account Manager'
    },
    securePasswordPolicy: {
      atLeast1Digit: 'Min. eine Ziffer',
      atLeast1Lowercase: 'Min. ein Kleinbuchstabe',
      atLeast1Uppercase: 'Min. ein Grossbuchstabe',
      atLeast8Characters: 'Min. 8 Stellen',
      tooltip: 'Min. 8 Stellen, inkl. mindestens ein Klein-, ein Grossbuchstabe und einer Ziffer'
    },
    sign: 'E-signatur',
    signWaitingText: 'Bitte warten. Wir leiten Sie zu unserem E-Signatur-Partner weiter...',
    title: 'Einen Nutzer für Ihre Firma hinzufügen',
    updateButton: 'Weiter'
  },
  vitrine: {
    access: {
      confirm: 'Meine Referenzliste erstellen',
      text1: '__sDigitalisierung der Baureferenzliste__s',
      text2: 'Finden Sie heraus, wie Sie Ihre Baureferenzliste über die OnceForAll-Plattform erstellen und hochladen können.',
      text3: 'Über unsere Online-Schnittstelle können Sie alle Informationen zu Ihren Referenzen eingeben, Fotos hinzufügen und die Liste in das am besten geeignete Format exportieren.',
      text4: '__sSparen Sie Zeit bei der Beantwortung von Ausschreibungen__s dank dieser Funktion, die es Ihnen ermöglicht, __sIhre Referenzen auf einer einzigen Plattform zu sammeln und Ihr Know-how und Ihre Leistungen zu präsentieren.__s',
      text5: 'Um mehr darüber zu erfahren, klicken Sie hier.',
      text6: 'Wenn Sie auf "Meine Referenzliste erstellen" klicken, werden Ihr Benutzerkonto und Ihr(e) Unternehmen auf der OnceForAll-Plattform automatisch synchronisiert.'
    },
    discover: {
      cancel: 'Ich möchte meine Referenzliste nicht erstellen',
      cta: 'JETZT PROBIEREN',
      text1: '__sNEU: Erstellen und downloaden Sie Ihre Referenzliste mit wenigen Klicks.__s',
      text2: 'Sammeln Sie Ihre Referenzen - Präsentieren Sie Ihr Know-how und Ihre Leistungen - Sparen Sie Zeit'
    }
  }
};
